import { _ as g, a as I, b as _r, c as $, d as J, e as po } from "./tslib.es6-59e1c9d8.js";
import * as G from "react";
import on, { createContext as At, useContext as j, useLayoutEffect as ho, useEffect as W, useState as Nr, useRef as et, useCallback as Ue, useMemo as Nt, forwardRef as mo, createElement as go, cloneElement as yo, Children as bo, isValidElement as Po } from "react";
var Ln = "production", an = typeof process > "u" || process.env === void 0 ? Ln : process.env.NODE_ENV || Ln, rt = function(t) {
  return {
    isEnabled: function(e) {
      return t.some(function(n) {
        return !!e[n];
      });
    }
  };
}, Ut = {
  measureLayout: rt(["layout", "layoutId", "drag"]),
  animation: rt([
    "animate",
    "exit",
    "variants",
    "whileHover",
    "whileTap",
    "whileFocus",
    "whileDrag",
    "whileInView"
  ]),
  exit: rt(["exit"]),
  drag: rt(["drag", "dragControls"]),
  focus: rt(["whileFocus"]),
  hover: rt(["whileHover", "onHoverStart", "onHoverEnd"]),
  tap: rt(["whileTap", "onTap", "onTapStart", "onTapCancel"]),
  pan: rt([
    "onPan",
    "onPanStart",
    "onPanSessionStart",
    "onPanEnd"
  ]),
  inView: rt([
    "whileInView",
    "onViewportEnter",
    "onViewportLeave"
  ])
};
function To(t) {
  for (var e in t)
    t[e] !== null && (e === "projectionNodeConstructor" ? Ut.projectionNodeConstructor = t[e] : Ut[e].Component = t[e]);
}
var Wt = function() {
}, Y = function() {
};
process.env.NODE_ENV !== "production" && (Wt = function(t, e) {
  !t && typeof console < "u" && console.warn(e);
}, Y = function(t, e) {
  if (!t)
    throw new Error(e);
});
var Ur = At({ strict: !1 }), Hr = Object.keys(Ut), xo = Hr.length;
function So(t, e, n) {
  var r = [], i = j(Ur);
  if (!e)
    return null;
  an !== "production" && n && i.strict && Y(!1, "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.");
  for (var s = 0; s < xo; s++) {
    var o = Hr[s], a = Ut[o], u = a.isEnabled, l = a.Component;
    u(t) && l && r.push(G.createElement(l, g({ key: o }, t, { visualElement: e })));
  }
  return r;
}
var sn = At({
  transformPagePoint: function(t) {
    return t;
  },
  isStatic: !1,
  reducedMotion: "never"
}), Te = At({});
function Vo() {
  return j(Te).visualElement;
}
var Yt = At(null), Ct = typeof document < "u", fe = Ct ? ho : W, He = { current: null }, kr = !1;
function wo() {
  if (kr = !0, !!Ct)
    if (window.matchMedia) {
      var t = window.matchMedia("(prefers-reduced-motion)"), e = function() {
        return He.current = t.matches;
      };
      t.addListener(e), e();
    } else
      He.current = !1;
}
function Ao() {
  !kr && wo();
  var t = I(Nr(He.current), 1), e = t[0];
  return e;
}
function Co() {
  var t = Ao(), e = j(sn).reducedMotion;
  return e === "never" ? !1 : e === "always" ? !0 : t;
}
function Eo(t, e, n, r) {
  var i = j(Ur), s = Vo(), o = j(Yt), a = Co(), u = et(void 0);
  r || (r = i.renderer), !u.current && r && (u.current = r(t, {
    visualState: e,
    parent: s,
    props: n,
    presenceId: o == null ? void 0 : o.id,
    blockInitialAnimation: (o == null ? void 0 : o.initial) === !1,
    shouldReduceMotion: a
  }));
  var l = u.current;
  return fe(function() {
    l == null || l.syncRender();
  }), W(function() {
    var c;
    (c = l == null ? void 0 : l.animationState) === null || c === void 0 || c.animateChanges();
  }), fe(function() {
    return function() {
      return l == null ? void 0 : l.notifyUnmount();
    };
  }, []), l;
}
function Pt(t) {
  return typeof t == "object" && Object.prototype.hasOwnProperty.call(t, "current");
}
function Mo(t, e, n) {
  return Ue(
    function(r) {
      var i;
      r && ((i = t.mount) === null || i === void 0 || i.call(t, r)), e && (r ? e.mount(r) : e.unmount()), n && (typeof n == "function" ? n(r) : Pt(n) && (n.current = r));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [e]
  );
}
function zr(t) {
  return Array.isArray(t);
}
function q(t) {
  return typeof t == "string" || zr(t);
}
function Ro(t) {
  var e = {};
  return t.forEachValue(function(n, r) {
    return e[r] = n.get();
  }), e;
}
function Lo(t) {
  var e = {};
  return t.forEachValue(function(n, r) {
    return e[r] = n.getVelocity();
  }), e;
}
function Kr(t, e, n, r, i) {
  var s;
  return r === void 0 && (r = {}), i === void 0 && (i = {}), typeof e == "function" && (e = e(n ?? t.custom, r, i)), typeof e == "string" && (e = (s = t.variants) === null || s === void 0 ? void 0 : s[e]), typeof e == "function" && (e = e(n ?? t.custom, r, i)), e;
}
function xe(t, e, n) {
  var r = t.getProps();
  return Kr(r, e, n ?? r.custom, Ro(t), Lo(t));
}
function Se(t) {
  var e;
  return typeof ((e = t.animate) === null || e === void 0 ? void 0 : e.start) == "function" || q(t.initial) || q(t.animate) || q(t.whileHover) || q(t.whileDrag) || q(t.whileTap) || q(t.whileFocus) || q(t.exit);
}
function Gr(t) {
  return !!(Se(t) || t.variants);
}
function Do(t, e) {
  if (Se(t)) {
    var n = t.initial, r = t.animate;
    return {
      initial: n === !1 || q(n) ? n : void 0,
      animate: q(r) ? r : void 0
    };
  }
  return t.inherit !== !1 ? e : {};
}
function Oo(t) {
  var e = Do(t, j(Te)), n = e.initial, r = e.animate;
  return Nt(function() {
    return { initial: n, animate: r };
  }, [Dn(n), Dn(r)]);
}
function Dn(t) {
  return Array.isArray(t) ? t.join(" ") : t;
}
function $t(t) {
  var e = et(null);
  return e.current === null && (e.current = t()), e.current;
}
var Dt = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
}, Io = 1;
function Fo() {
  return $t(function() {
    if (Dt.hasEverUpdated)
      return Io++;
  });
}
var un = At({}), Wr = At({});
function jo(t, e, n, r) {
  var i, s = e.layoutId, o = e.layout, a = e.drag, u = e.dragConstraints, l = e.layoutScroll, c = j(Wr);
  !r || !n || n != null && n.projection || (n.projection = new r(t, n.getLatestValues(), (i = n.parent) === null || i === void 0 ? void 0 : i.projection), n.projection.setOptions({
    layoutId: s,
    layout: o,
    alwaysMeasureLayout: !!a || u && Pt(u),
    visualElement: n,
    scheduleRender: function() {
      return n.scheduleRender();
    },
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof o == "string" ? o : "both",
    initialPromotionConfig: c,
    layoutScroll: l
  }));
}
var Bo = (
  /** @class */
  function(t) {
    _r(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.getSnapshotBeforeUpdate = function() {
      return this.updateProps(), null;
    }, e.prototype.componentDidUpdate = function() {
    }, e.prototype.updateProps = function() {
      var n = this.props, r = n.visualElement, i = n.props;
      r && r.setProps(i);
    }, e.prototype.render = function() {
      return this.props.children;
    }, e;
  }(on.Component)
);
function _o(t) {
  var e = t.preloadedFeatures, n = t.createVisualElement, r = t.projectionNodeConstructor, i = t.useRender, s = t.useVisualState, o = t.Component;
  e && To(e);
  function a(u, l) {
    var c = No(u);
    u = g(g({}, u), { layoutId: c });
    var f = j(sn), d = null, p = Oo(u), v = f.isStatic ? void 0 : Fo(), h = s(u, f.isStatic);
    return !f.isStatic && Ct && (p.visualElement = Eo(o, h, g(g({}, f), u), n), jo(v, u, p.visualElement, r || Ut.projectionNodeConstructor), d = So(u, p.visualElement, e)), G.createElement(
      Bo,
      { visualElement: p.visualElement, props: g(g({}, f), u) },
      d,
      G.createElement(Te.Provider, { value: p }, i(o, u, v, Mo(h, p.visualElement, l), h, f.isStatic, p.visualElement))
    );
  }
  return mo(a);
}
function No(t) {
  var e, n = t.layoutId, r = (e = j(un)) === null || e === void 0 ? void 0 : e.id;
  return r && n !== void 0 ? r + "-" + n : n;
}
function Uo(t) {
  function e(r, i) {
    return i === void 0 && (i = {}), _o(t(r, i));
  }
  if (typeof Proxy > "u")
    return e;
  var n = /* @__PURE__ */ new Map();
  return new Proxy(e, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: function(r, i) {
      return n.has(i) || n.set(i, e(i)), n.get(i);
    }
  });
}
var Ho = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "svg",
  "switch",
  "symbol",
  "text",
  "tspan",
  "use",
  "view"
];
function ln(t) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof t != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    t.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(Ho.indexOf(t) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/.test(t))
    )
  );
}
var de = {};
function ko(t) {
  Object.assign(de, t);
}
var ke = ["", "X", "Y", "Z"], zo = ["translate", "scale", "rotate", "skew"], Ht = ["transformPerspective", "x", "y", "z"];
zo.forEach(function(t) {
  return ke.forEach(function(e) {
    return Ht.push(t + e);
  });
});
function Ko(t, e) {
  return Ht.indexOf(t) - Ht.indexOf(e);
}
var Go = new Set(Ht);
function Xt(t) {
  return Go.has(t);
}
var Wo = /* @__PURE__ */ new Set(["originX", "originY", "originZ"]);
function Yr(t) {
  return Wo.has(t);
}
function $r(t, e) {
  var n = e.layout, r = e.layoutId;
  return Xt(t) || Yr(t) || (n || r !== void 0) && (!!de[t] || t === "opacity");
}
var it = function(t) {
  return !!(t !== null && typeof t == "object" && t.getVelocity);
}, Yo = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
};
function $o(t, e, n, r) {
  var i = t.transform, s = t.transformKeys, o = e.enableHardwareAcceleration, a = o === void 0 ? !0 : o, u = e.allowTransformNone, l = u === void 0 ? !0 : u, c = "";
  s.sort(Ko);
  for (var f = !1, d = s.length, p = 0; p < d; p++) {
    var v = s[p];
    c += "".concat(Yo[v] || v, "(").concat(i[v], ") "), v === "z" && (f = !0);
  }
  return !f && a ? c += "translateZ(0)" : c = c.trim(), r ? c = r(i, n ? "" : c) : l && n && (c = "none"), c;
}
function Xo(t) {
  var e = t.originX, n = e === void 0 ? "50%" : e, r = t.originY, i = r === void 0 ? "50%" : r, s = t.originZ, o = s === void 0 ? 0 : s;
  return "".concat(n, " ").concat(i, " ").concat(o);
}
function Xr(t) {
  return t.startsWith("--");
}
var Zo = function(t, e) {
  return e && typeof t == "number" ? e.transform(t) : t;
};
const Zr = (t, e) => (n) => Math.max(Math.min(n, e), t), Ot = (t) => t % 1 ? Number(t.toFixed(5)) : t, kt = /(-)?([\d]*\.?[\d])+/g, ze = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi, qo = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
function Zt(t) {
  return typeof t == "string";
}
const mt = {
  test: (t) => typeof t == "number",
  parse: parseFloat,
  transform: (t) => t
}, It = Object.assign(Object.assign({}, mt), { transform: Zr(0, 1) }), ee = Object.assign(Object.assign({}, mt), { default: 1 }), qt = (t) => ({
  test: (e) => Zt(e) && e.endsWith(t) && e.split(" ").length === 1,
  parse: parseFloat,
  transform: (e) => `${e}${t}`
}), ut = qt("deg"), nt = qt("%"), w = qt("px"), Jo = qt("vh"), Qo = qt("vw"), On = Object.assign(Object.assign({}, nt), { parse: (t) => nt.parse(t) / 100, transform: (t) => nt.transform(t * 100) }), cn = (t, e) => (n) => !!(Zt(n) && qo.test(n) && n.startsWith(t) || e && Object.prototype.hasOwnProperty.call(n, e)), qr = (t, e, n) => (r) => {
  if (!Zt(r))
    return r;
  const [i, s, o, a] = r.match(kt);
  return {
    [t]: parseFloat(i),
    [e]: parseFloat(s),
    [n]: parseFloat(o),
    alpha: a !== void 0 ? parseFloat(a) : 1
  };
}, ht = {
  test: cn("hsl", "hue"),
  parse: qr("hue", "saturation", "lightness"),
  transform: ({ hue: t, saturation: e, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(t) + ", " + nt.transform(Ot(e)) + ", " + nt.transform(Ot(n)) + ", " + Ot(It.transform(r)) + ")"
}, ta = Zr(0, 255), Me = Object.assign(Object.assign({}, mt), { transform: (t) => Math.round(ta(t)) }), ft = {
  test: cn("rgb", "red"),
  parse: qr("red", "green", "blue"),
  transform: ({ red: t, green: e, blue: n, alpha: r = 1 }) => "rgba(" + Me.transform(t) + ", " + Me.transform(e) + ", " + Me.transform(n) + ", " + Ot(It.transform(r)) + ")"
};
function ea(t) {
  let e = "", n = "", r = "", i = "";
  return t.length > 5 ? (e = t.substr(1, 2), n = t.substr(3, 2), r = t.substr(5, 2), i = t.substr(7, 2)) : (e = t.substr(1, 1), n = t.substr(2, 1), r = t.substr(3, 1), i = t.substr(4, 1), e += e, n += n, r += r, i += i), {
    red: parseInt(e, 16),
    green: parseInt(n, 16),
    blue: parseInt(r, 16),
    alpha: i ? parseInt(i, 16) / 255 : 1
  };
}
const Ke = {
  test: cn("#"),
  parse: ea,
  transform: ft.transform
}, U = {
  test: (t) => ft.test(t) || Ke.test(t) || ht.test(t),
  parse: (t) => ft.test(t) ? ft.parse(t) : ht.test(t) ? ht.parse(t) : Ke.parse(t),
  transform: (t) => Zt(t) ? t : t.hasOwnProperty("red") ? ft.transform(t) : ht.transform(t)
}, Jr = "${c}", Qr = "${n}";
function na(t) {
  var e, n, r, i;
  return isNaN(t) && Zt(t) && ((n = (e = t.match(kt)) === null || e === void 0 ? void 0 : e.length) !== null && n !== void 0 ? n : 0) + ((i = (r = t.match(ze)) === null || r === void 0 ? void 0 : r.length) !== null && i !== void 0 ? i : 0) > 0;
}
function ti(t) {
  typeof t == "number" && (t = `${t}`);
  const e = [];
  let n = 0;
  const r = t.match(ze);
  r && (n = r.length, t = t.replace(ze, Jr), e.push(...r.map(U.parse)));
  const i = t.match(kt);
  return i && (t = t.replace(kt, Qr), e.push(...i.map(mt.parse))), { values: e, numColors: n, tokenised: t };
}
function ei(t) {
  return ti(t).values;
}
function ni(t) {
  const { values: e, numColors: n, tokenised: r } = ti(t), i = e.length;
  return (s) => {
    let o = r;
    for (let a = 0; a < i; a++)
      o = o.replace(a < n ? Jr : Qr, a < n ? U.transform(s[a]) : Ot(s[a]));
    return o;
  };
}
const ra = (t) => typeof t == "number" ? 0 : t;
function ia(t) {
  const e = ei(t);
  return ni(t)(e.map(ra));
}
const ot = { test: na, parse: ei, createTransformer: ni, getAnimatableNone: ia }, oa = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function aa(t) {
  let [e, n] = t.slice(0, -1).split("(");
  if (e === "drop-shadow")
    return t;
  const [r] = n.match(kt) || [];
  if (!r)
    return t;
  const i = n.replace(r, "");
  let s = oa.has(e) ? 1 : 0;
  return r !== n && (s *= 100), e + "(" + s + i + ")";
}
const sa = /([a-z-]*)\(.*?\)/g, Ge = Object.assign(Object.assign({}, ot), { getAnimatableNone: (t) => {
  const e = t.match(sa);
  return e ? e.map(aa).join(" ") : t;
} });
var In = g(g({}, mt), { transform: Math.round }), ri = {
  // Border props
  borderWidth: w,
  borderTopWidth: w,
  borderRightWidth: w,
  borderBottomWidth: w,
  borderLeftWidth: w,
  borderRadius: w,
  radius: w,
  borderTopLeftRadius: w,
  borderTopRightRadius: w,
  borderBottomRightRadius: w,
  borderBottomLeftRadius: w,
  // Positioning props
  width: w,
  maxWidth: w,
  height: w,
  maxHeight: w,
  size: w,
  top: w,
  right: w,
  bottom: w,
  left: w,
  // Spacing props
  padding: w,
  paddingTop: w,
  paddingRight: w,
  paddingBottom: w,
  paddingLeft: w,
  margin: w,
  marginTop: w,
  marginRight: w,
  marginBottom: w,
  marginLeft: w,
  // Transform props
  rotate: ut,
  rotateX: ut,
  rotateY: ut,
  rotateZ: ut,
  scale: ee,
  scaleX: ee,
  scaleY: ee,
  scaleZ: ee,
  skew: ut,
  skewX: ut,
  skewY: ut,
  distance: w,
  translateX: w,
  translateY: w,
  translateZ: w,
  x: w,
  y: w,
  z: w,
  perspective: w,
  transformPerspective: w,
  opacity: It,
  originX: On,
  originY: On,
  originZ: w,
  // Misc
  zIndex: In,
  // SVG
  fillOpacity: It,
  strokeOpacity: It,
  numOctaves: In
};
function fn(t, e, n, r) {
  var i, s = t.style, o = t.vars, a = t.transform, u = t.transformKeys, l = t.transformOrigin;
  u.length = 0;
  var c = !1, f = !1, d = !0;
  for (var p in e) {
    var v = e[p];
    if (Xr(p)) {
      o[p] = v;
      continue;
    }
    var h = ri[p], m = Zo(v, h);
    if (Xt(p)) {
      if (c = !0, a[p] = m, u.push(p), !d)
        continue;
      v !== ((i = h.default) !== null && i !== void 0 ? i : 0) && (d = !1);
    } else
      Yr(p) ? (l[p] = m, f = !0) : s[p] = m;
  }
  c ? s.transform = $o(t, n, d, r) : r ? s.transform = r({}, "") : !e.transform && s.transform && (s.transform = "none"), f && (s.transformOrigin = Xo(l));
}
var dn = function() {
  return {
    style: {},
    transform: {},
    transformKeys: [],
    transformOrigin: {},
    vars: {}
  };
};
function ii(t, e, n) {
  for (var r in e)
    !it(e[r]) && !$r(r, n) && (t[r] = e[r]);
}
function ua(t, e, n) {
  var r = t.transformTemplate;
  return Nt(function() {
    var i = dn();
    fn(i, e, { enableHardwareAcceleration: !n }, r);
    var s = i.vars, o = i.style;
    return g(g({}, s), o);
  }, [e]);
}
function la(t, e, n) {
  var r = t.style || {}, i = {};
  return ii(i, r, t), Object.assign(i, ua(t, e, n)), t.transformValues && (i = t.transformValues(i)), i;
}
function ca(t, e, n) {
  var r = {}, i = la(t, e, n);
  return t.drag && t.dragListener !== !1 && (r.draggable = !1, i.userSelect = i.WebkitUserSelect = i.WebkitTouchCallout = "none", i.touchAction = t.drag === !0 ? "none" : "pan-".concat(t.drag === "x" ? "y" : "x")), r.style = i, r;
}
var fa = /* @__PURE__ */ new Set([
  "initial",
  "animate",
  "exit",
  "style",
  "variants",
  "transition",
  "transformTemplate",
  "transformValues",
  "custom",
  "inherit",
  "layout",
  "layoutId",
  "layoutDependency",
  "onLayoutAnimationStart",
  "onLayoutAnimationComplete",
  "onLayoutMeasure",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "drag",
  "dragControls",
  "dragListener",
  "dragConstraints",
  "dragDirectionLock",
  "dragSnapToOrigin",
  "_dragX",
  "_dragY",
  "dragElastic",
  "dragMomentum",
  "dragPropagation",
  "dragTransition",
  "whileDrag",
  "onPan",
  "onPanStart",
  "onPanEnd",
  "onPanSessionStart",
  "onTap",
  "onTapStart",
  "onTapCancel",
  "onHoverStart",
  "onHoverEnd",
  "whileFocus",
  "whileTap",
  "whileHover",
  "whileInView",
  "onViewportEnter",
  "onViewportLeave",
  "viewport",
  "layoutScroll"
]);
function ve(t) {
  return fa.has(t);
}
var oi = function(t) {
  return !ve(t);
};
function da(t) {
  t && (oi = function(e) {
    return e.startsWith("on") ? !ve(e) : t(e);
  });
}
try {
  da(require("@emotion/is-prop-valid").default);
} catch {
}
function va(t, e, n) {
  var r = {};
  for (var i in t)
    (oi(i) || n === !0 && ve(i) || !e && !ve(i) || // If trying to use native HTML drag events, forward drag listeners
    t.draggable && i.startsWith("onDrag")) && (r[i] = t[i]);
  return r;
}
function Fn(t, e, n) {
  return typeof t == "string" ? t : w.transform(e + n * t);
}
function pa(t, e, n) {
  var r = Fn(e, t.x, t.width), i = Fn(n, t.y, t.height);
  return "".concat(r, " ").concat(i);
}
var ha = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, ma = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function ga(t, e, n, r, i) {
  n === void 0 && (n = 1), r === void 0 && (r = 0), i === void 0 && (i = !0), t.pathLength = 1;
  var s = i ? ha : ma;
  t[s.offset] = w.transform(-r);
  var o = w.transform(e), a = w.transform(n);
  t[s.array] = "".concat(o, " ").concat(a);
}
function vn(t, e, n, r) {
  var i = e.attrX, s = e.attrY, o = e.originX, a = e.originY, u = e.pathLength, l = e.pathSpacing, c = l === void 0 ? 1 : l, f = e.pathOffset, d = f === void 0 ? 0 : f, p = $(e, ["attrX", "attrY", "originX", "originY", "pathLength", "pathSpacing", "pathOffset"]);
  fn(t, p, n, r), t.attrs = t.style, t.style = {};
  var v = t.attrs, h = t.style, m = t.dimensions;
  v.transform && (m && (h.transform = v.transform), delete v.transform), m && (o !== void 0 || a !== void 0 || h.transform) && (h.transformOrigin = pa(m, o !== void 0 ? o : 0.5, a !== void 0 ? a : 0.5)), i !== void 0 && (v.x = i), s !== void 0 && (v.y = s), u !== void 0 && ga(v, u, c, d, !1);
}
var ai = function() {
  return g(g({}, dn()), { attrs: {} });
};
function ya(t, e) {
  var n = Nt(function() {
    var i = ai();
    return vn(i, e, { enableHardwareAcceleration: !1 }, t.transformTemplate), g(g({}, i.attrs), { style: g({}, i.style) });
  }, [e]);
  if (t.style) {
    var r = {};
    ii(r, t.style, t), n.style = g(g({}, r), n.style);
  }
  return n;
}
function ba(t) {
  t === void 0 && (t = !1);
  var e = function(n, r, i, s, o, a) {
    var u = o.latestValues, l = ln(n) ? ya : ca, c = l(r, u, a), f = va(r, typeof n == "string", t), d = g(g(g({}, f), c), { ref: s });
    return i && (d["data-projection-id"] = i), go(n, d);
  };
  return e;
}
var Pa = /([a-z])([A-Z])/g, Ta = "$1-$2", si = function(t) {
  return t.replace(Pa, Ta).toLowerCase();
};
function ui(t, e, n, r) {
  var i = e.style, s = e.vars;
  Object.assign(t.style, i, r && r.getProjectionStyles(n));
  for (var o in s)
    t.style.setProperty(o, s[o]);
}
var li = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength"
]);
function ci(t, e, n, r) {
  ui(t, e, void 0, r);
  for (var i in e.attrs)
    t.setAttribute(li.has(i) ? i : si(i), e.attrs[i]);
}
function pn(t) {
  var e = t.style, n = {};
  for (var r in e)
    (it(e[r]) || $r(r, t)) && (n[r] = e[r]);
  return n;
}
function fi(t) {
  var e = pn(t);
  for (var n in t)
    if (it(t[n])) {
      var r = n === "x" || n === "y" ? "attr" + n.toUpperCase() : n;
      e[r] = t[n];
    }
  return e;
}
function hn(t) {
  return typeof t == "object" && typeof t.start == "function";
}
var zt = function(t) {
  return Array.isArray(t);
}, xa = function(t) {
  return !!(t && typeof t == "object" && t.mix && t.toValue);
}, di = function(t) {
  return zt(t) ? t[t.length - 1] || 0 : t;
};
function ue(t) {
  var e = it(t) ? t.get() : t;
  return xa(e) ? e.toValue() : e;
}
function jn(t, e, n, r) {
  var i = t.scrapeMotionValuesFromProps, s = t.createRenderState, o = t.onMount, a = {
    latestValues: Sa(e, n, r, i),
    renderState: s()
  };
  return o && (a.mount = function(u) {
    return o(e, u, a);
  }), a;
}
var vi = function(t) {
  return function(e, n) {
    var r = j(Te), i = j(Yt);
    return n ? jn(t, e, r, i) : $t(function() {
      return jn(t, e, r, i);
    });
  };
};
function Sa(t, e, n, r) {
  var i = {}, s = (n == null ? void 0 : n.initial) === !1, o = r(t);
  for (var a in o)
    i[a] = ue(o[a]);
  var u = t.initial, l = t.animate, c = Se(t), f = Gr(t);
  e && f && !c && t.inherit !== !1 && (u ?? (u = e.initial), l ?? (l = e.animate));
  var d = s || u === !1, p = d ? l : u;
  if (p && typeof p != "boolean" && !hn(p)) {
    var v = Array.isArray(p) ? p : [p];
    v.forEach(function(h) {
      var m = Kr(t, h);
      if (m) {
        var y = m.transitionEnd;
        m.transition;
        var P = $(m, ["transitionEnd", "transition"]);
        for (var b in P) {
          var T = P[b];
          if (Array.isArray(T)) {
            var S = d ? T.length - 1 : 0;
            T = T[S];
          }
          T !== null && (i[b] = T);
        }
        for (var b in y)
          i[b] = y[b];
      }
    });
  }
  return i;
}
var Va = {
  useVisualState: vi({
    scrapeMotionValuesFromProps: fi,
    createRenderState: ai,
    onMount: function(t, e, n) {
      var r = n.renderState, i = n.latestValues;
      try {
        r.dimensions = typeof e.getBBox == "function" ? e.getBBox() : e.getBoundingClientRect();
      } catch {
        r.dimensions = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      }
      vn(r, i, { enableHardwareAcceleration: !1 }, t.transformTemplate), ci(e, r);
    }
  })
}, wa = {
  useVisualState: vi({
    scrapeMotionValuesFromProps: pn,
    createRenderState: dn
  })
};
function Aa(t, e, n, r, i) {
  var s = e.forwardMotionProps, o = s === void 0 ? !1 : s, a = ln(t) ? Va : wa;
  return g(g({}, a), { preloadedFeatures: n, useRender: ba(o), createVisualElement: r, projectionNodeConstructor: i, Component: t });
}
var D;
(function(t) {
  t.Animate = "animate", t.Hover = "whileHover", t.Tap = "whileTap", t.Drag = "whileDrag", t.Focus = "whileFocus", t.InView = "whileInView", t.Exit = "exit";
})(D || (D = {}));
function Ve(t, e, n, r) {
  return r === void 0 && (r = { passive: !0 }), t.addEventListener(e, n, r), function() {
    return t.removeEventListener(e, n);
  };
}
function We(t, e, n, r) {
  W(function() {
    var i = t.current;
    if (n && i)
      return Ve(i, e, n, r);
  }, [t, e, n, r]);
}
function Ca(t) {
  var e = t.whileFocus, n = t.visualElement, r = function() {
    var s;
    (s = n.animationState) === null || s === void 0 || s.setActive(D.Focus, !0);
  }, i = function() {
    var s;
    (s = n.animationState) === null || s === void 0 || s.setActive(D.Focus, !1);
  };
  We(n, "focus", e ? r : void 0), We(n, "blur", e ? i : void 0);
}
function pi(t) {
  return typeof PointerEvent < "u" && t instanceof PointerEvent ? t.pointerType === "mouse" : t instanceof MouseEvent;
}
function hi(t) {
  var e = !!t.touches;
  return e;
}
function Ea(t) {
  return function(e) {
    var n = e instanceof MouseEvent, r = !n || n && e.button === 0;
    r && t(e);
  };
}
var Ma = { pageX: 0, pageY: 0 };
function Ra(t, e) {
  e === void 0 && (e = "page");
  var n = t.touches[0] || t.changedTouches[0], r = n || Ma;
  return {
    x: r[e + "X"],
    y: r[e + "Y"]
  };
}
function La(t, e) {
  return e === void 0 && (e = "page"), {
    x: t[e + "X"],
    y: t[e + "Y"]
  };
}
function mn(t, e) {
  return e === void 0 && (e = "page"), {
    point: hi(t) ? Ra(t, e) : La(t, e)
  };
}
var mi = function(t, e) {
  e === void 0 && (e = !1);
  var n = function(r) {
    return t(r, mn(r));
  };
  return e ? Ea(n) : n;
}, Da = function() {
  return Ct && window.onpointerdown === null;
}, Oa = function() {
  return Ct && window.ontouchstart === null;
}, Ia = function() {
  return Ct && window.onmousedown === null;
}, Fa = {
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointercancel: "mousecancel",
  pointerover: "mouseover",
  pointerout: "mouseout",
  pointerenter: "mouseenter",
  pointerleave: "mouseleave"
}, ja = {
  pointerdown: "touchstart",
  pointermove: "touchmove",
  pointerup: "touchend",
  pointercancel: "touchcancel"
};
function gi(t) {
  return Da() ? t : Oa() ? ja[t] : Ia() ? Fa[t] : t;
}
function xt(t, e, n, r) {
  return Ve(t, gi(e), mi(n, e === "pointerdown"), r);
}
function pe(t, e, n, r) {
  return We(t, gi(e), n && mi(n, e === "pointerdown"), r);
}
function yi(t) {
  var e = null;
  return function() {
    var n = function() {
      e = null;
    };
    return e === null ? (e = t, n) : !1;
  };
}
var Bn = yi("dragHorizontal"), _n = yi("dragVertical");
function bi(t) {
  var e = !1;
  if (t === "y")
    e = _n();
  else if (t === "x")
    e = Bn();
  else {
    var n = Bn(), r = _n();
    n && r ? e = function() {
      n(), r();
    } : (n && n(), r && r());
  }
  return e;
}
function Pi() {
  var t = bi(!0);
  return t ? (t(), !1) : !0;
}
function Nn(t, e, n) {
  return function(r, i) {
    var s;
    !pi(r) || Pi() || ((s = t.animationState) === null || s === void 0 || s.setActive(D.Hover, e), n == null || n(r, i));
  };
}
function Ba(t) {
  var e = t.onHoverStart, n = t.onHoverEnd, r = t.whileHover, i = t.visualElement;
  pe(i, "pointerenter", e || r ? Nn(i, !0, e) : void 0, { passive: !e }), pe(i, "pointerleave", n || r ? Nn(i, !1, n) : void 0, { passive: !n });
}
var Ti = function(t, e) {
  return e ? t === e ? !0 : Ti(t, e.parentElement) : !1;
};
function gn(t) {
  return W(function() {
    return function() {
      return t();
    };
  }, []);
}
const he = (t, e, n) => Math.min(Math.max(n, t), e), Re = 1e-3, _a = 0.01, Un = 10, Na = 0.05, Ua = 1;
function Ha({ duration: t = 800, bounce: e = 0.25, velocity: n = 0, mass: r = 1 }) {
  let i, s;
  Wt(t <= Un * 1e3, "Spring duration must be 10 seconds or less");
  let o = 1 - e;
  o = he(Na, Ua, o), t = he(_a, Un, t / 1e3), o < 1 ? (i = (l) => {
    const c = l * o, f = c * t, d = c - n, p = Ye(l, o), v = Math.exp(-f);
    return Re - d / p * v;
  }, s = (l) => {
    const f = l * o * t, d = f * n + n, p = Math.pow(o, 2) * Math.pow(l, 2) * t, v = Math.exp(-f), h = Ye(Math.pow(l, 2), o);
    return (-i(l) + Re > 0 ? -1 : 1) * ((d - p) * v) / h;
  }) : (i = (l) => {
    const c = Math.exp(-l * t), f = (l - n) * t + 1;
    return -Re + c * f;
  }, s = (l) => {
    const c = Math.exp(-l * t), f = (n - l) * (t * t);
    return c * f;
  });
  const a = 5 / t, u = za(i, s, a);
  if (t = t * 1e3, isNaN(u))
    return {
      stiffness: 100,
      damping: 10,
      duration: t
    };
  {
    const l = Math.pow(u, 2) * r;
    return {
      stiffness: l,
      damping: o * 2 * Math.sqrt(r * l),
      duration: t
    };
  }
}
const ka = 12;
function za(t, e, n) {
  let r = n;
  for (let i = 1; i < ka; i++)
    r = r - t(r) / e(r);
  return r;
}
function Ye(t, e) {
  return t * Math.sqrt(1 - e * e);
}
const Ka = ["duration", "bounce"], Ga = ["stiffness", "damping", "mass"];
function Hn(t, e) {
  return e.some((n) => t[n] !== void 0);
}
function Wa(t) {
  let e = Object.assign({ velocity: 0, stiffness: 100, damping: 10, mass: 1, isResolvedFromDuration: !1 }, t);
  if (!Hn(t, Ga) && Hn(t, Ka)) {
    const n = Ha(t);
    e = Object.assign(Object.assign(Object.assign({}, e), n), { velocity: 0, mass: 1 }), e.isResolvedFromDuration = !0;
  }
  return e;
}
function yn(t) {
  var { from: e = 0, to: n = 1, restSpeed: r = 2, restDelta: i } = t, s = $(t, ["from", "to", "restSpeed", "restDelta"]);
  const o = { done: !1, value: e };
  let { stiffness: a, damping: u, mass: l, velocity: c, duration: f, isResolvedFromDuration: d } = Wa(s), p = kn, v = kn;
  function h() {
    const m = c ? -(c / 1e3) : 0, y = n - e, P = u / (2 * Math.sqrt(a * l)), b = Math.sqrt(a / l) / 1e3;
    if (i === void 0 && (i = Math.min(Math.abs(n - e) / 100, 0.4)), P < 1) {
      const T = Ye(b, P);
      p = (S) => {
        const E = Math.exp(-P * b * S);
        return n - E * ((m + P * b * y) / T * Math.sin(T * S) + y * Math.cos(T * S));
      }, v = (S) => {
        const E = Math.exp(-P * b * S);
        return P * b * E * (Math.sin(T * S) * (m + P * b * y) / T + y * Math.cos(T * S)) - E * (Math.cos(T * S) * (m + P * b * y) - T * y * Math.sin(T * S));
      };
    } else if (P === 1)
      p = (T) => n - Math.exp(-b * T) * (y + (m + b * y) * T);
    else {
      const T = b * Math.sqrt(P * P - 1);
      p = (S) => {
        const E = Math.exp(-P * b * S), M = Math.min(T * S, 300);
        return n - E * ((m + P * b * y) * Math.sinh(M) + T * y * Math.cosh(M)) / T;
      };
    }
  }
  return h(), {
    next: (m) => {
      const y = p(m);
      if (d)
        o.done = m >= f;
      else {
        const P = v(m) * 1e3, b = Math.abs(P) <= r, T = Math.abs(n - y) <= i;
        o.done = b && T;
      }
      return o.value = o.done ? n : y, o;
    },
    flipTarget: () => {
      c = -c, [e, n] = [n, e], h();
    }
  };
}
yn.needsInterpolation = (t, e) => typeof t == "string" || typeof e == "string";
const kn = (t) => 0, Kt = (t, e, n) => {
  const r = e - t;
  return r === 0 ? 1 : (n - t) / r;
}, O = (t, e, n) => -n * t + n * e + t;
function Le(t, e, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t + (e - t) * 6 * n : n < 1 / 2 ? e : n < 2 / 3 ? t + (e - t) * (2 / 3 - n) * 6 : t;
}
function zn({ hue: t, saturation: e, lightness: n, alpha: r }) {
  t /= 360, e /= 100, n /= 100;
  let i = 0, s = 0, o = 0;
  if (!e)
    i = s = o = n;
  else {
    const a = n < 0.5 ? n * (1 + e) : n + e - n * e, u = 2 * n - a;
    i = Le(u, a, t + 1 / 3), s = Le(u, a, t), o = Le(u, a, t - 1 / 3);
  }
  return {
    red: Math.round(i * 255),
    green: Math.round(s * 255),
    blue: Math.round(o * 255),
    alpha: r
  };
}
const Ya = (t, e, n) => {
  const r = t * t, i = e * e;
  return Math.sqrt(Math.max(0, n * (i - r) + r));
}, $a = [Ke, ft, ht], Kn = (t) => $a.find((e) => e.test(t)), Gn = (t) => `'${t}' is not an animatable color. Use the equivalent color code instead.`, xi = (t, e) => {
  let n = Kn(t), r = Kn(e);
  Y(!!n, Gn(t)), Y(!!r, Gn(e));
  let i = n.parse(t), s = r.parse(e);
  n === ht && (i = zn(i), n = ft), r === ht && (s = zn(s), r = ft);
  const o = Object.assign({}, i);
  return (a) => {
    for (const u in o)
      u !== "alpha" && (o[u] = Ya(i[u], s[u], a));
    return o.alpha = O(i.alpha, s.alpha, a), n.transform(o);
  };
}, $e = (t) => typeof t == "number", Xa = (t, e) => (n) => e(t(n)), we = (...t) => t.reduce(Xa);
function Si(t, e) {
  return $e(t) ? (n) => O(t, e, n) : U.test(t) ? xi(t, e) : wi(t, e);
}
const Vi = (t, e) => {
  const n = [...t], r = n.length, i = t.map((s, o) => Si(s, e[o]));
  return (s) => {
    for (let o = 0; o < r; o++)
      n[o] = i[o](s);
    return n;
  };
}, Za = (t, e) => {
  const n = Object.assign(Object.assign({}, t), e), r = {};
  for (const i in n)
    t[i] !== void 0 && e[i] !== void 0 && (r[i] = Si(t[i], e[i]));
  return (i) => {
    for (const s in r)
      n[s] = r[s](i);
    return n;
  };
};
function Wn(t) {
  const e = ot.parse(t), n = e.length;
  let r = 0, i = 0, s = 0;
  for (let o = 0; o < n; o++)
    r || typeof e[o] == "number" ? r++ : e[o].hue !== void 0 ? s++ : i++;
  return { parsed: e, numNumbers: r, numRGB: i, numHSL: s };
}
const wi = (t, e) => {
  const n = ot.createTransformer(e), r = Wn(t), i = Wn(e);
  return r.numHSL === i.numHSL && r.numRGB === i.numRGB && r.numNumbers >= i.numNumbers ? we(Vi(r.parsed, i.parsed), n) : (Wt(!0, `Complex values '${t}' and '${e}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), (o) => `${o > 0 ? e : t}`);
}, qa = (t, e) => (n) => O(t, e, n);
function Ja(t) {
  if (typeof t == "number")
    return qa;
  if (typeof t == "string")
    return U.test(t) ? xi : wi;
  if (Array.isArray(t))
    return Vi;
  if (typeof t == "object")
    return Za;
}
function Qa(t, e, n) {
  const r = [], i = n || Ja(t[0]), s = t.length - 1;
  for (let o = 0; o < s; o++) {
    let a = i(t[o], t[o + 1]);
    if (e) {
      const u = Array.isArray(e) ? e[o] : e;
      a = we(u, a);
    }
    r.push(a);
  }
  return r;
}
function ts([t, e], [n]) {
  return (r) => n(Kt(t, e, r));
}
function es(t, e) {
  const n = t.length, r = n - 1;
  return (i) => {
    let s = 0, o = !1;
    if (i <= t[0] ? o = !0 : i >= t[r] && (s = r - 1, o = !0), !o) {
      let u = 1;
      for (; u < n && !(t[u] > i || u === r); u++)
        ;
      s = u - 1;
    }
    const a = Kt(t[s], t[s + 1], i);
    return e[s](a);
  };
}
function Ai(t, e, { clamp: n = !0, ease: r, mixer: i } = {}) {
  const s = t.length;
  Y(s === e.length, "Both input and output ranges must be the same length"), Y(!r || !Array.isArray(r) || r.length === s - 1, "Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values."), t[0] > t[s - 1] && (t = [].concat(t), e = [].concat(e), t.reverse(), e.reverse());
  const o = Qa(e, r, i), a = s === 2 ? ts(t, o) : es(t, o);
  return n ? (u) => a(he(t[0], t[s - 1], u)) : a;
}
const Ae = (t) => (e) => 1 - t(1 - e), bn = (t) => (e) => e <= 0.5 ? t(2 * e) / 2 : (2 - t(2 * (1 - e))) / 2, ns = (t) => (e) => Math.pow(e, t), Ci = (t) => (e) => e * e * ((t + 1) * e - t), rs = (t) => {
  const e = Ci(t);
  return (n) => (n *= 2) < 1 ? 0.5 * e(n) : 0.5 * (2 - Math.pow(2, -10 * (n - 1)));
}, Ei = 1.525, is = 4 / 11, os = 8 / 11, as = 9 / 10, Pn = (t) => t, Tn = ns(2), ss = Ae(Tn), Mi = bn(Tn), Ri = (t) => 1 - Math.sin(Math.acos(t)), xn = Ae(Ri), us = bn(xn), Sn = Ci(Ei), ls = Ae(Sn), cs = bn(Sn), fs = rs(Ei), ds = 4356 / 361, vs = 35442 / 1805, ps = 16061 / 1805, me = (t) => {
  if (t === 1 || t === 0)
    return t;
  const e = t * t;
  return t < is ? 7.5625 * e : t < os ? 9.075 * e - 9.9 * t + 3.4 : t < as ? ds * e - vs * t + ps : 10.8 * t * t - 20.52 * t + 10.72;
}, hs = Ae(me), ms = (t) => t < 0.5 ? 0.5 * (1 - me(1 - t * 2)) : 0.5 * me(t * 2 - 1) + 0.5;
function gs(t, e) {
  return t.map(() => e || Mi).splice(0, t.length - 1);
}
function ys(t) {
  const e = t.length;
  return t.map((n, r) => r !== 0 ? r / (e - 1) : 0);
}
function bs(t, e) {
  return t.map((n) => n * e);
}
function le({ from: t = 0, to: e = 1, ease: n, offset: r, duration: i = 300 }) {
  const s = { done: !1, value: t }, o = Array.isArray(e) ? e : [t, e], a = bs(r && r.length === o.length ? r : ys(o), i);
  function u() {
    return Ai(a, o, {
      ease: Array.isArray(n) ? n : gs(o, n)
    });
  }
  let l = u();
  return {
    next: (c) => (s.value = l(c), s.done = c >= i, s),
    flipTarget: () => {
      o.reverse(), l = u();
    }
  };
}
function Ps({ velocity: t = 0, from: e = 0, power: n = 0.8, timeConstant: r = 350, restDelta: i = 0.5, modifyTarget: s }) {
  const o = { done: !1, value: e };
  let a = n * t;
  const u = e + a, l = s === void 0 ? u : s(u);
  return l !== u && (a = l - e), {
    next: (c) => {
      const f = -a * Math.exp(-c / r);
      return o.done = !(f > i || f < -i), o.value = o.done ? l : l + f, o;
    },
    flipTarget: () => {
    }
  };
}
const Yn = { keyframes: le, spring: yn, decay: Ps };
function Ts(t) {
  if (Array.isArray(t.to))
    return le;
  if (Yn[t.type])
    return Yn[t.type];
  const e = new Set(Object.keys(t));
  return e.has("ease") || e.has("duration") && !e.has("dampingRatio") ? le : e.has("dampingRatio") || e.has("stiffness") || e.has("mass") || e.has("damping") || e.has("restSpeed") || e.has("restDelta") ? yn : le;
}
const Li = 1 / 60 * 1e3, xs = typeof performance < "u" ? () => performance.now() : () => Date.now(), Di = typeof window < "u" ? (t) => window.requestAnimationFrame(t) : (t) => setTimeout(() => t(xs()), Li);
function Ss(t) {
  let e = [], n = [], r = 0, i = !1, s = !1;
  const o = /* @__PURE__ */ new WeakSet(), a = {
    schedule: (u, l = !1, c = !1) => {
      const f = c && i, d = f ? e : n;
      return l && o.add(u), d.indexOf(u) === -1 && (d.push(u), f && i && (r = e.length)), u;
    },
    cancel: (u) => {
      const l = n.indexOf(u);
      l !== -1 && n.splice(l, 1), o.delete(u);
    },
    process: (u) => {
      if (i) {
        s = !0;
        return;
      }
      if (i = !0, [e, n] = [n, e], n.length = 0, r = e.length, r)
        for (let l = 0; l < r; l++) {
          const c = e[l];
          c(u), o.has(c) && (a.schedule(c), t());
        }
      i = !1, s && (s = !1, a.process(u));
    }
  };
  return a;
}
const Vs = 40;
let Xe = !0, Gt = !1, Ze = !1;
const St = {
  delta: 0,
  timestamp: 0
}, Jt = [
  "read",
  "update",
  "preRender",
  "render",
  "postRender"
], Ce = Jt.reduce((t, e) => (t[e] = Ss(() => Gt = !0), t), {}), Q = Jt.reduce((t, e) => {
  const n = Ce[e];
  return t[e] = (r, i = !1, s = !1) => (Gt || As(), n.schedule(r, i, s)), t;
}, {}), Vt = Jt.reduce((t, e) => (t[e] = Ce[e].cancel, t), {}), De = Jt.reduce((t, e) => (t[e] = () => Ce[e].process(St), t), {}), ws = (t) => Ce[t].process(St), Oi = (t) => {
  Gt = !1, St.delta = Xe ? Li : Math.max(Math.min(t - St.timestamp, Vs), 1), St.timestamp = t, Ze = !0, Jt.forEach(ws), Ze = !1, Gt && (Xe = !1, Di(Oi));
}, As = () => {
  Gt = !0, Xe = !0, Ze || Di(Oi);
}, ge = () => St;
function Ii(t, e, n = 0) {
  return t - e - n;
}
function Cs(t, e, n = 0, r = !0) {
  return r ? Ii(e + -t, e, n) : e - (t - e) + n;
}
function Es(t, e, n, r) {
  return r ? t >= e + n : t <= -n;
}
const Ms = (t) => {
  const e = ({ delta: n }) => t(n);
  return {
    start: () => Q.update(e, !0),
    stop: () => Vt.update(e)
  };
};
function Fi(t) {
  var e, n, { from: r, autoplay: i = !0, driver: s = Ms, elapsed: o = 0, repeat: a = 0, repeatType: u = "loop", repeatDelay: l = 0, onPlay: c, onStop: f, onComplete: d, onRepeat: p, onUpdate: v } = t, h = $(t, ["from", "autoplay", "driver", "elapsed", "repeat", "repeatType", "repeatDelay", "onPlay", "onStop", "onComplete", "onRepeat", "onUpdate"]);
  let { to: m } = h, y, P = 0, b = h.duration, T, S = !1, E = !0, M;
  const A = Ts(h);
  !((n = (e = A).needsInterpolation) === null || n === void 0) && n.call(e, r, m) && (M = Ai([0, 100], [r, m], {
    clamp: !1
  }), r = 0, m = 100);
  const C = A(Object.assign(Object.assign({}, h), { from: r, to: m }));
  function L() {
    P++, u === "reverse" ? (E = P % 2 === 0, o = Cs(o, b, l, E)) : (o = Ii(o, b, l), u === "mirror" && C.flipTarget()), S = !1, p && p();
  }
  function H() {
    y.stop(), d && d();
  }
  function F(z) {
    if (E || (z = -z), o += z, !S) {
      const X = C.next(Math.max(0, o));
      T = X.value, M && (T = M(T)), S = E ? X.done : o <= 0;
    }
    v == null || v(T), S && (P === 0 && (b ?? (b = o)), P < a ? Es(o, b, l, E) && L() : H());
  }
  function _() {
    c == null || c(), y = s(F), y.start();
  }
  return i && _(), {
    stop: () => {
      f == null || f(), y.stop();
    }
  };
}
function ji(t, e) {
  return e ? t * (1e3 / e) : 0;
}
function Rs({ from: t = 0, velocity: e = 0, min: n, max: r, power: i = 0.8, timeConstant: s = 750, bounceStiffness: o = 500, bounceDamping: a = 10, restDelta: u = 1, modifyTarget: l, driver: c, onUpdate: f, onComplete: d, onStop: p }) {
  let v;
  function h(b) {
    return n !== void 0 && b < n || r !== void 0 && b > r;
  }
  function m(b) {
    return n === void 0 ? r : r === void 0 || Math.abs(n - b) < Math.abs(r - b) ? n : r;
  }
  function y(b) {
    v == null || v.stop(), v = Fi(Object.assign(Object.assign({}, b), {
      driver: c,
      onUpdate: (T) => {
        var S;
        f == null || f(T), (S = b.onUpdate) === null || S === void 0 || S.call(b, T);
      },
      onComplete: d,
      onStop: p
    }));
  }
  function P(b) {
    y(Object.assign({ type: "spring", stiffness: o, damping: a, restDelta: u }, b));
  }
  if (h(t))
    P({ from: t, velocity: e, to: m(t) });
  else {
    let b = i * e + t;
    typeof l < "u" && (b = l(b));
    const T = m(b), S = T === n ? -1 : 1;
    let E, M;
    const A = (C) => {
      E = M, M = C, e = ji(C - E, ge().delta), (S === 1 && C > T || S === -1 && C < T) && P({ from: C, to: T, velocity: e });
    };
    y({
      type: "decay",
      from: t,
      velocity: e,
      timeConstant: s,
      power: i,
      restDelta: u,
      modifyTarget: l,
      onUpdate: h(b) ? A : void 0
    });
  }
  return {
    stop: () => v == null ? void 0 : v.stop()
  };
}
const qe = (t) => t.hasOwnProperty("x") && t.hasOwnProperty("y"), $n = (t) => qe(t) && t.hasOwnProperty("z"), ne = (t, e) => Math.abs(t - e);
function Bi(t, e) {
  if ($e(t) && $e(e))
    return ne(t, e);
  if (qe(t) && qe(e)) {
    const n = ne(t.x, e.x), r = ne(t.y, e.y), i = $n(t) && $n(e) ? ne(t.z, e.z) : 0;
    return Math.sqrt(Math.pow(n, 2) + Math.pow(r, 2) + Math.pow(i, 2));
  }
}
const _i = (t, e) => 1 - 3 * e + 3 * t, Ni = (t, e) => 3 * e - 6 * t, Ui = (t) => 3 * t, ye = (t, e, n) => ((_i(e, n) * t + Ni(e, n)) * t + Ui(e)) * t, Hi = (t, e, n) => 3 * _i(e, n) * t * t + 2 * Ni(e, n) * t + Ui(e), Ls = 1e-7, Ds = 10;
function Os(t, e, n, r, i) {
  let s, o, a = 0;
  do
    o = e + (n - e) / 2, s = ye(o, r, i) - t, s > 0 ? n = o : e = o;
  while (Math.abs(s) > Ls && ++a < Ds);
  return o;
}
const Is = 8, Fs = 1e-3;
function js(t, e, n, r) {
  for (let i = 0; i < Is; ++i) {
    const s = Hi(e, n, r);
    if (s === 0)
      return e;
    const o = ye(e, n, r) - t;
    e -= o / s;
  }
  return e;
}
const ce = 11, re = 1 / (ce - 1);
function Bs(t, e, n, r) {
  if (t === e && n === r)
    return Pn;
  const i = new Float32Array(ce);
  for (let o = 0; o < ce; ++o)
    i[o] = ye(o * re, t, n);
  function s(o) {
    let a = 0, u = 1;
    const l = ce - 1;
    for (; u !== l && i[u] <= o; ++u)
      a += re;
    --u;
    const c = (o - i[u]) / (i[u + 1] - i[u]), f = a + c * re, d = Hi(f, t, n);
    return d >= Fs ? js(o, f, t, n) : d === 0 ? f : Os(o, a, a + re, t, n);
  }
  return (o) => o === 0 || o === 1 ? o : ye(s(o), e, r);
}
function _s(t) {
  var e = t.onTap, n = t.onTapStart, r = t.onTapCancel, i = t.whileTap, s = t.visualElement, o = e || n || r || i, a = et(!1), u = et(null), l = {
    passive: !(n || e || r || v)
  };
  function c() {
    var h;
    (h = u.current) === null || h === void 0 || h.call(u), u.current = null;
  }
  function f() {
    var h;
    return c(), a.current = !1, (h = s.animationState) === null || h === void 0 || h.setActive(D.Tap, !1), !Pi();
  }
  function d(h, m) {
    f() && (Ti(s.getInstance(), h.target) ? e == null || e(h, m) : r == null || r(h, m));
  }
  function p(h, m) {
    f() && (r == null || r(h, m));
  }
  function v(h, m) {
    var y;
    c(), !a.current && (a.current = !0, u.current = we(xt(window, "pointerup", d, l), xt(window, "pointercancel", p, l)), (y = s.animationState) === null || y === void 0 || y.setActive(D.Tap, !0), n == null || n(h, m));
  }
  pe(s, "pointerdown", o ? v : void 0, l), gn(c);
}
var Xn = /* @__PURE__ */ new Set();
function ki(t, e, n) {
  t || Xn.has(e) || (console.warn(e), n && console.warn(n), Xn.add(e));
}
var Je = /* @__PURE__ */ new WeakMap(), Oe = /* @__PURE__ */ new WeakMap(), Ns = function(t) {
  var e;
  (e = Je.get(t.target)) === null || e === void 0 || e(t);
}, Us = function(t) {
  t.forEach(Ns);
};
function Hs(t) {
  var e = t.root, n = $(t, ["root"]), r = e || document;
  Oe.has(r) || Oe.set(r, {});
  var i = Oe.get(r), s = JSON.stringify(n);
  return i[s] || (i[s] = new IntersectionObserver(Us, g({ root: e }, n))), i[s];
}
function ks(t, e, n) {
  var r = Hs(e);
  return Je.set(t, n), r.observe(t), function() {
    Je.delete(t), r.unobserve(t);
  };
}
function zs(t) {
  var e = t.visualElement, n = t.whileInView, r = t.onViewportEnter, i = t.onViewportLeave, s = t.viewport, o = s === void 0 ? {} : s, a = et({
    hasEnteredView: !1,
    isInView: !1
  }), u = !!(n || r || i);
  o.once && a.current.hasEnteredView && (u = !1);
  var l = typeof IntersectionObserver > "u" ? Ws : Gs;
  l(u, a.current, e, o);
}
var Ks = {
  some: 0,
  all: 1
};
function Gs(t, e, n, r) {
  var i = r.root, s = r.margin, o = r.amount, a = o === void 0 ? "some" : o, u = r.once;
  W(function() {
    if (t) {
      var l = {
        root: i == null ? void 0 : i.current,
        rootMargin: s,
        threshold: typeof a == "number" ? a : Ks[a]
      }, c = function(f) {
        var d, p = f.isIntersecting;
        if (e.isInView !== p && (e.isInView = p, !(u && !p && e.hasEnteredView))) {
          p && (e.hasEnteredView = !0), (d = n.animationState) === null || d === void 0 || d.setActive(D.InView, p);
          var v = n.getProps(), h = p ? v.onViewportEnter : v.onViewportLeave;
          h == null || h(f);
        }
      };
      return ks(n.getInstance(), l, c);
    }
  }, [t, i, s, a]);
}
function Ws(t, e, n, r) {
  var i = r.fallback, s = i === void 0 ? !0 : i;
  W(function() {
    !t || !s || (an !== "production" && ki(!1, "IntersectionObserver not available on this device. whileInView animations will trigger on mount."), requestAnimationFrame(function() {
      var o;
      e.hasEnteredView = !0;
      var a = n.getProps().onViewportEnter;
      a == null || a(null), (o = n.animationState) === null || o === void 0 || o.setActive(D.InView, !0);
    }));
  }, [t]);
}
var dt = function(t) {
  return function(e) {
    return t(e), null;
  };
}, Ys = {
  inView: dt(zs),
  tap: dt(_s),
  focus: dt(Ca),
  hover: dt(Ba)
}, $s = 0, Xs = function() {
  return $s++;
}, zi = function() {
  return $t(Xs);
};
function Ki() {
  var t = j(Yt);
  if (t === null)
    return [!0, null];
  var e = t.isPresent, n = t.onExitComplete, r = t.register, i = zi();
  W(function() {
    return r(i);
  }, []);
  var s = function() {
    return n == null ? void 0 : n(i);
  };
  return !e && n ? [!1, s] : [!0];
}
function Gi(t, e) {
  if (!Array.isArray(e))
    return !1;
  var n = e.length;
  if (n !== t.length)
    return !1;
  for (var r = 0; r < n; r++)
    if (e[r] !== t[r])
      return !1;
  return !0;
}
var be = function(t) {
  return t * 1e3;
}, Zn = {
  linear: Pn,
  easeIn: Tn,
  easeInOut: Mi,
  easeOut: ss,
  circIn: Ri,
  circInOut: us,
  circOut: xn,
  backIn: Sn,
  backInOut: cs,
  backOut: ls,
  anticipate: fs,
  bounceIn: hs,
  bounceInOut: ms,
  bounceOut: me
}, qn = function(t) {
  if (Array.isArray(t)) {
    Y(t.length === 4, "Cubic bezier arrays must contain four numerical values.");
    var e = I(t, 4), n = e[0], r = e[1], i = e[2], s = e[3];
    return Bs(n, r, i, s);
  } else if (typeof t == "string")
    return Y(Zn[t] !== void 0, "Invalid easing type '".concat(t, "'")), Zn[t];
  return t;
}, Zs = function(t) {
  return Array.isArray(t) && typeof t[0] != "number";
}, Jn = function(t, e) {
  return t === "zIndex" ? !1 : !!(typeof e == "number" || Array.isArray(e) || typeof e == "string" && // It's animatable if we have a string
  ot.test(e) && // And it contains numbers and/or colors
  !e.startsWith("url("));
}, vt = function() {
  return {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
  };
}, ie = function(t) {
  return {
    type: "spring",
    stiffness: 550,
    damping: t === 0 ? 2 * Math.sqrt(550) : 30,
    restSpeed: 10
  };
}, Ie = function() {
  return {
    type: "keyframes",
    ease: "linear",
    duration: 0.3
  };
}, qs = function(t) {
  return {
    type: "keyframes",
    duration: 0.8,
    values: t
  };
}, Qn = {
  x: vt,
  y: vt,
  z: vt,
  rotate: vt,
  rotateX: vt,
  rotateY: vt,
  rotateZ: vt,
  scaleX: ie,
  scaleY: ie,
  scale: ie,
  opacity: Ie,
  backgroundColor: Ie,
  color: Ie,
  default: ie
}, Js = function(t, e) {
  var n;
  return zt(e) ? n = qs : n = Qn[t] || Qn.default, g({ to: e }, n(e));
}, Qs = g(g({}, ri), {
  // Color props
  color: U,
  backgroundColor: U,
  outlineColor: U,
  fill: U,
  stroke: U,
  // Border props
  borderColor: U,
  borderTopColor: U,
  borderRightColor: U,
  borderBottomColor: U,
  borderLeftColor: U,
  filter: Ge,
  WebkitFilter: Ge
}), Vn = function(t) {
  return Qs[t];
};
function wn(t, e) {
  var n, r = Vn(t);
  return r !== Ge && (r = ot), (n = r.getAnimatableNone) === null || n === void 0 ? void 0 : n.call(r, e);
}
function tu(t) {
  t.when, t.delay, t.delayChildren, t.staggerChildren, t.staggerDirection, t.repeat, t.repeatType, t.repeatDelay, t.from;
  var e = $(t, ["when", "delay", "delayChildren", "staggerChildren", "staggerDirection", "repeat", "repeatType", "repeatDelay", "from"]);
  return !!Object.keys(e).length;
}
var tr = !1;
function eu(t) {
  var e = t.ease, n = t.times, r = t.yoyo, i = t.flip, s = t.loop, o = $(t, ["ease", "times", "yoyo", "flip", "loop"]), a = g({}, o);
  return n && (a.offset = n), o.duration && (a.duration = be(o.duration)), o.repeatDelay && (a.repeatDelay = be(o.repeatDelay)), e && (a.ease = Zs(e) ? e.map(qn) : qn(e)), o.type === "tween" && (a.type = "keyframes"), (r || s || i) && (Wt(!tr, "yoyo, loop and flip have been removed from the API. Replace with repeat and repeatType options."), tr = !0, r ? a.repeatType = "reverse" : s ? a.repeatType = "loop" : i && (a.repeatType = "mirror"), a.repeat = s || r || i || o.repeat), o.type !== "spring" && (a.type = "keyframes"), a;
}
function nu(t, e) {
  var n, r, i = An(t, e) || {};
  return (r = (n = i.delay) !== null && n !== void 0 ? n : t.delay) !== null && r !== void 0 ? r : 0;
}
function ru(t) {
  return Array.isArray(t.to) && t.to[0] === null && (t.to = J([], I(t.to), !1), t.to[0] = t.from), t;
}
function iu(t, e, n) {
  var r;
  return Array.isArray(e.to) && ((r = t.duration) !== null && r !== void 0 || (t.duration = 0.8)), ru(e), tu(t) || (t = g(g({}, t), Js(n, e.to))), g(g({}, e), eu(t));
}
function ou(t, e, n, r, i) {
  var s, o = An(r, t), a = (s = o.from) !== null && s !== void 0 ? s : e.get(), u = Jn(t, n);
  a === "none" && u && typeof n == "string" ? a = wn(t, n) : er(a) && typeof n == "string" ? a = nr(n) : !Array.isArray(n) && er(n) && typeof a == "string" && (n = nr(a));
  var l = Jn(t, a);
  Wt(l === u, "You are trying to animate ".concat(t, ' from "').concat(a, '" to "').concat(n, '". ').concat(a, " is not an animatable value - to enable this animation set ").concat(a, " to a value animatable to ").concat(n, " via the `style` property."));
  function c() {
    var d = {
      from: a,
      to: n,
      velocity: e.getVelocity(),
      onComplete: i,
      onUpdate: function(p) {
        return e.set(p);
      }
    };
    return o.type === "inertia" || o.type === "decay" ? Rs(g(g({}, d), o)) : Fi(g(g({}, iu(o, d, t)), { onUpdate: function(p) {
      var v;
      d.onUpdate(p), (v = o.onUpdate) === null || v === void 0 || v.call(o, p);
    }, onComplete: function() {
      var p;
      d.onComplete(), (p = o.onComplete) === null || p === void 0 || p.call(o);
    } }));
  }
  function f() {
    var d, p, v = di(n);
    return e.set(v), i(), (d = o == null ? void 0 : o.onUpdate) === null || d === void 0 || d.call(o, v), (p = o == null ? void 0 : o.onComplete) === null || p === void 0 || p.call(o), { stop: function() {
    } };
  }
  return !l || !u || o.type === !1 ? f : c;
}
function er(t) {
  return t === 0 || typeof t == "string" && parseFloat(t) === 0 && t.indexOf(" ") === -1;
}
function nr(t) {
  return typeof t == "number" ? 0 : wn("", t);
}
function An(t, e) {
  return t[e] || t.default || t;
}
function Cn(t, e, n, r) {
  return r === void 0 && (r = {}), e.start(function(i) {
    var s, o, a = ou(t, e, n, r, i), u = nu(r, t), l = function() {
      return o = a();
    };
    return u ? s = window.setTimeout(l, be(u)) : l(), function() {
      clearTimeout(s), o == null || o.stop();
    };
  });
}
var au = function(t) {
  return /^\-?\d*\.?\d+$/.test(t);
}, su = function(t) {
  return /^0[^.\s]+$/.test(t);
};
function En(t, e) {
  t.indexOf(e) === -1 && t.push(e);
}
function Mn(t, e) {
  var n = t.indexOf(e);
  n > -1 && t.splice(n, 1);
}
var Ft = (
  /** @class */
  function() {
    function t() {
      this.subscriptions = [];
    }
    return t.prototype.add = function(e) {
      var n = this;
      return En(this.subscriptions, e), function() {
        return Mn(n.subscriptions, e);
      };
    }, t.prototype.notify = function(e, n, r) {
      var i = this.subscriptions.length;
      if (i)
        if (i === 1)
          this.subscriptions[0](e, n, r);
        else
          for (var s = 0; s < i; s++) {
            var o = this.subscriptions[s];
            o && o(e, n, r);
          }
    }, t.prototype.getSize = function() {
      return this.subscriptions.length;
    }, t.prototype.clear = function() {
      this.subscriptions.length = 0;
    }, t;
  }()
), uu = function(t) {
  return !isNaN(parseFloat(t));
}, lu = (
  /** @class */
  function() {
    function t(e) {
      var n = this;
      this.version = "6.5.1", this.timeDelta = 0, this.lastUpdated = 0, this.updateSubscribers = new Ft(), this.velocityUpdateSubscribers = new Ft(), this.renderSubscribers = new Ft(), this.canTrackVelocity = !1, this.updateAndNotify = function(r, i) {
        i === void 0 && (i = !0), n.prev = n.current, n.current = r;
        var s = ge(), o = s.delta, a = s.timestamp;
        n.lastUpdated !== a && (n.timeDelta = o, n.lastUpdated = a, Q.postRender(n.scheduleVelocityCheck)), n.prev !== n.current && n.updateSubscribers.notify(n.current), n.velocityUpdateSubscribers.getSize() && n.velocityUpdateSubscribers.notify(n.getVelocity()), i && n.renderSubscribers.notify(n.current);
      }, this.scheduleVelocityCheck = function() {
        return Q.postRender(n.velocityCheck);
      }, this.velocityCheck = function(r) {
        var i = r.timestamp;
        i !== n.lastUpdated && (n.prev = n.current, n.velocityUpdateSubscribers.notify(n.getVelocity()));
      }, this.hasAnimated = !1, this.prev = this.current = e, this.canTrackVelocity = uu(this.current);
    }
    return t.prototype.onChange = function(e) {
      return this.updateSubscribers.add(e);
    }, t.prototype.clearListeners = function() {
      this.updateSubscribers.clear();
    }, t.prototype.onRenderRequest = function(e) {
      return e(this.get()), this.renderSubscribers.add(e);
    }, t.prototype.attach = function(e) {
      this.passiveEffect = e;
    }, t.prototype.set = function(e, n) {
      n === void 0 && (n = !0), !n || !this.passiveEffect ? this.updateAndNotify(e, n) : this.passiveEffect(e, this.updateAndNotify);
    }, t.prototype.get = function() {
      return this.current;
    }, t.prototype.getPrevious = function() {
      return this.prev;
    }, t.prototype.getVelocity = function() {
      return this.canTrackVelocity ? (
        // These casts could be avoided if parseFloat would be typed better
        ji(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta)
      ) : 0;
    }, t.prototype.start = function(e) {
      var n = this;
      return this.stop(), new Promise(function(r) {
        n.hasAnimated = !0, n.stopAnimation = e(r);
      }).then(function() {
        return n.clearAnimation();
      });
    }, t.prototype.stop = function() {
      this.stopAnimation && this.stopAnimation(), this.clearAnimation();
    }, t.prototype.isAnimating = function() {
      return !!this.stopAnimation;
    }, t.prototype.clearAnimation = function() {
      this.stopAnimation = null;
    }, t.prototype.destroy = function() {
      this.updateSubscribers.clear(), this.renderSubscribers.clear(), this.stop();
    }, t;
  }()
);
function wt(t) {
  return new lu(t);
}
var Wi = function(t) {
  return function(e) {
    return e.test(t);
  };
}, cu = {
  test: function(t) {
    return t === "auto";
  },
  parse: function(t) {
    return t;
  }
}, Yi = [mt, w, nt, ut, Qo, Jo, cu], Rt = function(t) {
  return Yi.find(Wi(t));
}, fu = J(J([], I(Yi), !1), [U, ot], !1), du = function(t) {
  return fu.find(Wi(t));
};
function vu(t, e, n) {
  t.hasValue(e) ? t.getValue(e).set(n) : t.addValue(e, wt(n));
}
function pu(t, e) {
  var n = xe(t, e), r = n ? t.makeTargetAnimatable(n, !1) : {}, i = r.transitionEnd, s = i === void 0 ? {} : i;
  r.transition;
  var o = $(r, ["transitionEnd", "transition"]);
  o = g(g({}, o), s);
  for (var a in o) {
    var u = di(o[a]);
    vu(t, a, u);
  }
}
function hu(t, e, n) {
  var r, i, s, o, a = Object.keys(e).filter(function(p) {
    return !t.hasValue(p);
  }), u = a.length;
  if (u)
    for (var l = 0; l < u; l++) {
      var c = a[l], f = e[c], d = null;
      Array.isArray(f) && (d = f[0]), d === null && (d = (i = (r = n[c]) !== null && r !== void 0 ? r : t.readValue(c)) !== null && i !== void 0 ? i : e[c]), d != null && (typeof d == "string" && (au(d) || su(d)) ? d = parseFloat(d) : !du(d) && ot.test(f) && (d = wn(c, f)), t.addValue(c, wt(d)), (s = (o = n)[c]) !== null && s !== void 0 || (o[c] = d), t.setBaseTarget(c, d));
    }
}
function mu(t, e) {
  if (e) {
    var n = e[t] || e.default || e;
    return n.from;
  }
}
function gu(t, e, n) {
  var r, i, s = {};
  for (var o in t)
    s[o] = (r = mu(o, e)) !== null && r !== void 0 ? r : (i = n.getValue(o)) === null || i === void 0 ? void 0 : i.get();
  return s;
}
function yu(t, e, n) {
  n === void 0 && (n = {}), t.notifyAnimationStart(e);
  var r;
  if (Array.isArray(e)) {
    var i = e.map(function(o) {
      return Qe(t, o, n);
    });
    r = Promise.all(i);
  } else if (typeof e == "string")
    r = Qe(t, e, n);
  else {
    var s = typeof e == "function" ? xe(t, e, n.custom) : e;
    r = $i(t, s, n);
  }
  return r.then(function() {
    return t.notifyAnimationComplete(e);
  });
}
function Qe(t, e, n) {
  var r;
  n === void 0 && (n = {});
  var i = xe(t, e, n.custom), s = (i || {}).transition, o = s === void 0 ? t.getDefaultTransition() || {} : s;
  n.transitionOverride && (o = n.transitionOverride);
  var a = i ? function() {
    return $i(t, i, n);
  } : function() {
    return Promise.resolve();
  }, u = !((r = t.variantChildren) === null || r === void 0) && r.size ? function(p) {
    p === void 0 && (p = 0);
    var v = o.delayChildren, h = v === void 0 ? 0 : v, m = o.staggerChildren, y = o.staggerDirection;
    return bu(t, e, h + p, m, y, n);
  } : function() {
    return Promise.resolve();
  }, l = o.when;
  if (l) {
    var c = I(l === "beforeChildren" ? [a, u] : [u, a], 2), f = c[0], d = c[1];
    return f().then(d);
  } else
    return Promise.all([a(), u(n.delay)]);
}
function $i(t, e, n) {
  var r, i = n === void 0 ? {} : n, s = i.delay, o = s === void 0 ? 0 : s, a = i.transitionOverride, u = i.type, l = t.makeTargetAnimatable(e), c = l.transition, f = c === void 0 ? t.getDefaultTransition() : c, d = l.transitionEnd, p = $(l, ["transition", "transitionEnd"]);
  a && (f = a);
  var v = [], h = u && ((r = t.animationState) === null || r === void 0 ? void 0 : r.getState()[u]);
  for (var m in p) {
    var y = t.getValue(m), P = p[m];
    if (!(!y || P === void 0 || h && Tu(h, m))) {
      var b = g({ delay: o }, f);
      t.shouldReduceMotion && Xt(m) && (b = g(g({}, b), { type: !1, delay: 0 }));
      var T = Cn(m, y, P, b);
      v.push(T);
    }
  }
  return Promise.all(v).then(function() {
    d && pu(t, d);
  });
}
function bu(t, e, n, r, i, s) {
  n === void 0 && (n = 0), r === void 0 && (r = 0), i === void 0 && (i = 1);
  var o = [], a = (t.variantChildren.size - 1) * r, u = i === 1 ? function(l) {
    return l === void 0 && (l = 0), l * r;
  } : function(l) {
    return l === void 0 && (l = 0), a - l * r;
  };
  return Array.from(t.variantChildren).sort(Pu).forEach(function(l, c) {
    o.push(Qe(l, e, g(g({}, s), { delay: n + u(c) })).then(function() {
      return l.notifyAnimationComplete(e);
    }));
  }), Promise.all(o);
}
function Pu(t, e) {
  return t.sortNodePosition(e);
}
function Tu(t, e) {
  var n = t.protectedKeys, r = t.needsAnimating, i = n.hasOwnProperty(e) && r[e] !== !0;
  return r[e] = !1, i;
}
var Rn = [
  D.Animate,
  D.InView,
  D.Focus,
  D.Hover,
  D.Tap,
  D.Drag,
  D.Exit
], xu = J([], I(Rn), !1).reverse(), Su = Rn.length;
function Vu(t) {
  return function(e) {
    return Promise.all(e.map(function(n) {
      var r = n.animation, i = n.options;
      return yu(t, r, i);
    }));
  };
}
function wu(t) {
  var e = Vu(t), n = Cu(), r = {}, i = !0, s = function(c, f) {
    var d = xe(t, f);
    if (d) {
      d.transition;
      var p = d.transitionEnd, v = $(d, ["transition", "transitionEnd"]);
      c = g(g(g({}, c), v), p);
    }
    return c;
  };
  function o(c) {
    return r[c] !== void 0;
  }
  function a(c) {
    e = c(t);
  }
  function u(c, f) {
    for (var d, p = t.getProps(), v = t.getVariantContext(!0) || {}, h = [], m = /* @__PURE__ */ new Set(), y = {}, P = 1 / 0, b = function(M) {
      var A = xu[M], C = n[A], L = (d = p[A]) !== null && d !== void 0 ? d : v[A], H = q(L), F = A === f ? C.isActive : null;
      F === !1 && (P = M);
      var _ = L === v[A] && L !== p[A] && H;
      if (_ && i && t.manuallyAnimateOnMount && (_ = !1), C.protectedKeys = g({}, y), // If it isn't active and hasn't *just* been set as inactive
      !C.isActive && F === null || // If we didn't and don't have any defined prop for this animation type
      !L && !C.prevProp || // Or if the prop doesn't define an animation
      hn(L) || typeof L == "boolean")
        return "continue";
      var z = Au(C.prevProp, L), X = z || // If we're making this variant active, we want to always make it active
      A === f && C.isActive && !_ && H || // If we removed a higher-priority variant (i is in reverse order)
      M > P && H, st = Array.isArray(L) ? L : [L], K = st.reduce(s, {});
      F === !1 && (K = {});
      var Et = C.prevResolvedValues, gt = Et === void 0 ? {} : Et, Qt = g(g({}, gt), K), yt = function(V) {
        X = !0, m.delete(V), C.needsAnimating[V] = !0;
      };
      for (var k in Qt) {
        var R = K[k], x = gt[k];
        y.hasOwnProperty(k) || (R !== x ? zt(R) && zt(x) ? !Gi(R, x) || z ? yt(k) : C.protectedKeys[k] = !0 : R !== void 0 ? yt(k) : m.add(k) : R !== void 0 && m.has(k) ? yt(k) : C.protectedKeys[k] = !0);
      }
      C.prevProp = L, C.prevResolvedValues = K, C.isActive && (y = g(g({}, y), K)), i && t.blockInitialAnimation && (X = !1), X && !_ && h.push.apply(h, J([], I(st.map(function(V) {
        return {
          animation: V,
          options: g({ type: A }, c)
        };
      })), !1));
    }, T = 0; T < Su; T++)
      b(T);
    if (r = g({}, y), m.size) {
      var S = {};
      m.forEach(function(M) {
        var A = t.getBaseTarget(M);
        A !== void 0 && (S[M] = A);
      }), h.push({ animation: S });
    }
    var E = !!h.length;
    return i && p.initial === !1 && !t.manuallyAnimateOnMount && (E = !1), i = !1, E ? e(h) : Promise.resolve();
  }
  function l(c, f, d) {
    var p;
    if (n[c].isActive === f)
      return Promise.resolve();
    (p = t.variantChildren) === null || p === void 0 || p.forEach(function(m) {
      var y;
      return (y = m.animationState) === null || y === void 0 ? void 0 : y.setActive(c, f);
    }), n[c].isActive = f;
    var v = u(d, c);
    for (var h in n)
      n[h].protectedKeys = {};
    return v;
  }
  return {
    isAnimated: o,
    animateChanges: u,
    setActive: l,
    setAnimateFunction: a,
    getState: function() {
      return n;
    }
  };
}
function Au(t, e) {
  return typeof e == "string" ? e !== t : zr(e) ? !Gi(e, t) : !1;
}
function pt(t) {
  return t === void 0 && (t = !1), {
    isActive: t,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function Cu() {
  var t;
  return t = {}, t[D.Animate] = pt(!0), t[D.InView] = pt(), t[D.Hover] = pt(), t[D.Tap] = pt(), t[D.Drag] = pt(), t[D.Focus] = pt(), t[D.Exit] = pt(), t;
}
var Eu = {
  animation: dt(function(t) {
    var e = t.visualElement, n = t.animate;
    e.animationState || (e.animationState = wu(e)), hn(n) && W(function() {
      return n.subscribe(e);
    }, [n]);
  }),
  exit: dt(function(t) {
    var e = t.custom, n = t.visualElement, r = I(Ki(), 2), i = r[0], s = r[1], o = j(Yt);
    W(function() {
      var a, u;
      n.isPresent = i;
      var l = (a = n.animationState) === null || a === void 0 ? void 0 : a.setActive(D.Exit, !i, { custom: (u = o == null ? void 0 : o.custom) !== null && u !== void 0 ? u : e });
      !i && (l == null || l.then(s));
    }, [i]);
  })
}, Xi = (
  /** @class */
  function() {
    function t(e, n, r) {
      var i = this, s = r === void 0 ? {} : r, o = s.transformPagePoint;
      if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.updatePoint = function() {
        if (i.lastMoveEvent && i.lastMoveEventInfo) {
          var d = je(i.lastMoveEventInfo, i.history), p = i.startEvent !== null, v = Bi(d.offset, { x: 0, y: 0 }) >= 3;
          if (!(!p && !v)) {
            var h = d.point, m = ge().timestamp;
            i.history.push(g(g({}, h), { timestamp: m }));
            var y = i.handlers, P = y.onStart, b = y.onMove;
            p || (P && P(i.lastMoveEvent, d), i.startEvent = i.lastMoveEvent), b && b(i.lastMoveEvent, d);
          }
        }
      }, this.handlePointerMove = function(d, p) {
        if (i.lastMoveEvent = d, i.lastMoveEventInfo = Fe(p, i.transformPagePoint), pi(d) && d.buttons === 0) {
          i.handlePointerUp(d, p);
          return;
        }
        Q.update(i.updatePoint, !0);
      }, this.handlePointerUp = function(d, p) {
        i.end();
        var v = i.handlers, h = v.onEnd, m = v.onSessionEnd, y = je(Fe(p, i.transformPagePoint), i.history);
        i.startEvent && h && h(d, y), m && m(d, y);
      }, !(hi(e) && e.touches.length > 1)) {
        this.handlers = n, this.transformPagePoint = o;
        var a = mn(e), u = Fe(a, this.transformPagePoint), l = u.point, c = ge().timestamp;
        this.history = [g(g({}, l), { timestamp: c })];
        var f = n.onSessionStart;
        f && f(e, je(u, this.history)), this.removeListeners = we(xt(window, "pointermove", this.handlePointerMove), xt(window, "pointerup", this.handlePointerUp), xt(window, "pointercancel", this.handlePointerUp));
      }
    }
    return t.prototype.updateHandlers = function(e) {
      this.handlers = e;
    }, t.prototype.end = function() {
      this.removeListeners && this.removeListeners(), Vt.update(this.updatePoint);
    }, t;
  }()
);
function Fe(t, e) {
  return e ? { point: e(t.point) } : t;
}
function rr(t, e) {
  return { x: t.x - e.x, y: t.y - e.y };
}
function je(t, e) {
  var n = t.point;
  return {
    point: n,
    delta: rr(n, Zi(e)),
    offset: rr(n, Mu(e)),
    velocity: Ru(e, 0.1)
  };
}
function Mu(t) {
  return t[0];
}
function Zi(t) {
  return t[t.length - 1];
}
function Ru(t, e) {
  if (t.length < 2)
    return { x: 0, y: 0 };
  for (var n = t.length - 1, r = null, i = Zi(t); n >= 0 && (r = t[n], !(i.timestamp - r.timestamp > be(e))); )
    n--;
  if (!r)
    return { x: 0, y: 0 };
  var s = (i.timestamp - r.timestamp) / 1e3;
  if (s === 0)
    return { x: 0, y: 0 };
  var o = {
    x: (i.x - r.x) / s,
    y: (i.y - r.y) / s
  };
  return o.x === 1 / 0 && (o.x = 0), o.y === 1 / 0 && (o.y = 0), o;
}
function at(t) {
  return t.max - t.min;
}
function ir(t, e, n) {
  return e === void 0 && (e = 0), n === void 0 && (n = 0.01), Bi(t, e) < n;
}
function or(t, e, n, r) {
  r === void 0 && (r = 0.5), t.origin = r, t.originPoint = O(e.min, e.max, t.origin), t.scale = at(n) / at(e), (ir(t.scale, 1, 1e-4) || isNaN(t.scale)) && (t.scale = 1), t.translate = O(n.min, n.max, t.origin) - t.originPoint, (ir(t.translate) || isNaN(t.translate)) && (t.translate = 0);
}
function jt(t, e, n, r) {
  or(t.x, e.x, n.x, r == null ? void 0 : r.originX), or(t.y, e.y, n.y, r == null ? void 0 : r.originY);
}
function ar(t, e, n) {
  t.min = n.min + e.min, t.max = t.min + at(e);
}
function Lu(t, e, n) {
  ar(t.x, e.x, n.x), ar(t.y, e.y, n.y);
}
function sr(t, e, n) {
  t.min = e.min - n.min, t.max = t.min + at(e);
}
function Bt(t, e, n) {
  sr(t.x, e.x, n.x), sr(t.y, e.y, n.y);
}
function Du(t, e, n) {
  var r = e.min, i = e.max;
  return r !== void 0 && t < r ? t = n ? O(r, t, n.min) : Math.max(t, r) : i !== void 0 && t > i && (t = n ? O(i, t, n.max) : Math.min(t, i)), t;
}
function ur(t, e, n) {
  return {
    min: e !== void 0 ? t.min + e : void 0,
    max: n !== void 0 ? t.max + n - (t.max - t.min) : void 0
  };
}
function Ou(t, e) {
  var n = e.top, r = e.left, i = e.bottom, s = e.right;
  return {
    x: ur(t.x, r, s),
    y: ur(t.y, n, i)
  };
}
function lr(t, e) {
  var n, r = e.min - t.min, i = e.max - t.max;
  return e.max - e.min < t.max - t.min && (n = I([i, r], 2), r = n[0], i = n[1]), { min: r, max: i };
}
function Iu(t, e) {
  return {
    x: lr(t.x, e.x),
    y: lr(t.y, e.y)
  };
}
function Fu(t, e) {
  var n = 0.5, r = at(t), i = at(e);
  return i > r ? n = Kt(e.min, e.max - r, t.min) : r > i && (n = Kt(t.min, t.max - i, e.min)), he(0, 1, n);
}
function ju(t, e) {
  var n = {};
  return e.min !== void 0 && (n.min = e.min - t.min), e.max !== void 0 && (n.max = e.max - t.min), n;
}
var tn = 0.35;
function Bu(t) {
  return t === void 0 && (t = tn), t === !1 ? t = 0 : t === !0 && (t = tn), {
    x: cr(t, "left", "right"),
    y: cr(t, "top", "bottom")
  };
}
function cr(t, e, n) {
  return {
    min: fr(t, e),
    max: fr(t, n)
  };
}
function fr(t, e) {
  var n;
  return typeof t == "number" ? t : (n = t[e]) !== null && n !== void 0 ? n : 0;
}
var dr = function() {
  return {
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0
  };
}, _t = function() {
  return {
    x: dr(),
    y: dr()
  };
}, vr = function() {
  return { min: 0, max: 0 };
}, B = function() {
  return {
    x: vr(),
    y: vr()
  };
};
function tt(t) {
  return [t("x"), t("y")];
}
function qi(t) {
  var e = t.top, n = t.left, r = t.right, i = t.bottom;
  return {
    x: { min: n, max: r },
    y: { min: e, max: i }
  };
}
function _u(t) {
  var e = t.x, n = t.y;
  return { top: n.min, right: e.max, bottom: n.max, left: e.min };
}
function Nu(t, e) {
  if (!e)
    return t;
  var n = e({ x: t.left, y: t.top }), r = e({ x: t.right, y: t.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: r.y,
    right: r.x
  };
}
function Be(t) {
  return t === void 0 || t === 1;
}
function Ji(t) {
  var e = t.scale, n = t.scaleX, r = t.scaleY;
  return !Be(e) || !Be(n) || !Be(r);
}
function lt(t) {
  return Ji(t) || pr(t.x) || pr(t.y) || t.z || t.rotate || t.rotateX || t.rotateY;
}
function pr(t) {
  return t && t !== "0%";
}
function Pe(t, e, n) {
  var r = t - n, i = e * r;
  return n + i;
}
function hr(t, e, n, r, i) {
  return i !== void 0 && (t = Pe(t, i, r)), Pe(t, n, r) + e;
}
function en(t, e, n, r, i) {
  e === void 0 && (e = 0), n === void 0 && (n = 1), t.min = hr(t.min, e, n, r, i), t.max = hr(t.max, e, n, r, i);
}
function Qi(t, e) {
  var n = e.x, r = e.y;
  en(t.x, n.translate, n.scale, n.originPoint), en(t.y, r.translate, r.scale, r.originPoint);
}
function Uu(t, e, n, r) {
  var i, s;
  r === void 0 && (r = !1);
  var o = n.length;
  if (o) {
    e.x = e.y = 1;
    for (var a, u, l = 0; l < o; l++)
      a = n[l], u = a.projectionDelta, ((s = (i = a.instance) === null || i === void 0 ? void 0 : i.style) === null || s === void 0 ? void 0 : s.display) !== "contents" && (r && a.options.layoutScroll && a.scroll && a !== a.root && Tt(t, { x: -a.scroll.x, y: -a.scroll.y }), u && (e.x *= u.x.scale, e.y *= u.y.scale, Qi(t, u)), r && lt(a.latestValues) && Tt(t, a.latestValues));
  }
}
function ct(t, e) {
  t.min = t.min + e, t.max = t.max + e;
}
function mr(t, e, n) {
  var r = I(n, 3), i = r[0], s = r[1], o = r[2], a = e[o] !== void 0 ? e[o] : 0.5, u = O(t.min, t.max, a);
  en(t, e[i], e[s], u, e.scale);
}
var Hu = ["x", "scaleX", "originX"], ku = ["y", "scaleY", "originY"];
function Tt(t, e) {
  mr(t.x, e, Hu), mr(t.y, e, ku);
}
function to(t, e) {
  return qi(Nu(t.getBoundingClientRect(), e));
}
function zu(t, e, n) {
  var r = to(t, n), i = e.scroll;
  return i && (ct(r.x, i.x), ct(r.y, i.y)), r;
}
var Ku = /* @__PURE__ */ new WeakMap(), Gu = (
  /** @class */
  function() {
    function t(e) {
      this.openGlobalLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = B(), this.visualElement = e;
    }
    return t.prototype.start = function(e, n) {
      var r = this, i = n === void 0 ? {} : n, s = i.snapToCursor, o = s === void 0 ? !1 : s;
      if (this.visualElement.isPresent !== !1) {
        var a = function(f) {
          r.stopAnimation(), o && r.snapToCursor(mn(f, "page").point);
        }, u = function(f, d) {
          var p, v = r.getProps(), h = v.drag, m = v.dragPropagation, y = v.onDragStart;
          h && !m && (r.openGlobalLock && r.openGlobalLock(), r.openGlobalLock = bi(h), !r.openGlobalLock) || (r.isDragging = !0, r.currentDirection = null, r.resolveConstraints(), r.visualElement.projection && (r.visualElement.projection.isAnimationBlocked = !0, r.visualElement.projection.target = void 0), tt(function(P) {
            var b, T, S = r.getAxisMotionValue(P).get() || 0;
            if (nt.test(S)) {
              var E = (T = (b = r.visualElement.projection) === null || b === void 0 ? void 0 : b.layout) === null || T === void 0 ? void 0 : T.actual[P];
              if (E) {
                var M = at(E);
                S = M * (parseFloat(S) / 100);
              }
            }
            r.originPoint[P] = S;
          }), y == null || y(f, d), (p = r.visualElement.animationState) === null || p === void 0 || p.setActive(D.Drag, !0));
        }, l = function(f, d) {
          var p = r.getProps(), v = p.dragPropagation, h = p.dragDirectionLock, m = p.onDirectionLock, y = p.onDrag;
          if (!(!v && !r.openGlobalLock)) {
            var P = d.offset;
            if (h && r.currentDirection === null) {
              r.currentDirection = Wu(P), r.currentDirection !== null && (m == null || m(r.currentDirection));
              return;
            }
            r.updateAxis("x", d.point, P), r.updateAxis("y", d.point, P), r.visualElement.syncRender(), y == null || y(f, d);
          }
        }, c = function(f, d) {
          return r.stop(f, d);
        };
        this.panSession = new Xi(e, {
          onSessionStart: a,
          onStart: u,
          onMove: l,
          onSessionEnd: c
        }, { transformPagePoint: this.visualElement.getTransformPagePoint() });
      }
    }, t.prototype.stop = function(e, n) {
      var r = this.isDragging;
      if (this.cancel(), !!r) {
        var i = n.velocity;
        this.startAnimation(i);
        var s = this.getProps().onDragEnd;
        s == null || s(e, n);
      }
    }, t.prototype.cancel = function() {
      var e, n;
      this.isDragging = !1, this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !1), (e = this.panSession) === null || e === void 0 || e.end(), this.panSession = void 0;
      var r = this.getProps().dragPropagation;
      !r && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), (n = this.visualElement.animationState) === null || n === void 0 || n.setActive(D.Drag, !1);
    }, t.prototype.updateAxis = function(e, n, r) {
      var i = this.getProps().drag;
      if (!(!r || !oe(e, i, this.currentDirection))) {
        var s = this.getAxisMotionValue(e), o = this.originPoint[e] + r[e];
        this.constraints && this.constraints[e] && (o = Du(o, this.constraints[e], this.elastic[e])), s.set(o);
      }
    }, t.prototype.resolveConstraints = function() {
      var e = this, n = this.getProps(), r = n.dragConstraints, i = n.dragElastic, s = (this.visualElement.projection || {}).layout, o = this.constraints;
      r && Pt(r) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : r && s ? this.constraints = Ou(s.actual, r) : this.constraints = !1, this.elastic = Bu(i), o !== this.constraints && s && this.constraints && !this.hasMutatedConstraints && tt(function(a) {
        e.getAxisMotionValue(a) && (e.constraints[a] = ju(s.actual[a], e.constraints[a]));
      });
    }, t.prototype.resolveRefConstraints = function() {
      var e = this.getProps(), n = e.dragConstraints, r = e.onMeasureDragConstraints;
      if (!n || !Pt(n))
        return !1;
      var i = n.current;
      Y(i !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
      var s = this.visualElement.projection;
      if (!s || !s.layout)
        return !1;
      var o = zu(i, s.root, this.visualElement.getTransformPagePoint()), a = Iu(s.layout.actual, o);
      if (r) {
        var u = r(_u(a));
        this.hasMutatedConstraints = !!u, u && (a = qi(u));
      }
      return a;
    }, t.prototype.startAnimation = function(e) {
      var n = this, r = this.getProps(), i = r.drag, s = r.dragMomentum, o = r.dragElastic, a = r.dragTransition, u = r.dragSnapToOrigin, l = r.onDragTransitionEnd, c = this.constraints || {}, f = tt(function(d) {
        var p;
        if (oe(d, i, n.currentDirection)) {
          var v = (p = c == null ? void 0 : c[d]) !== null && p !== void 0 ? p : {};
          u && (v = { min: 0, max: 0 });
          var h = o ? 200 : 1e6, m = o ? 40 : 1e7, y = g(g({ type: "inertia", velocity: s ? e[d] : 0, bounceStiffness: h, bounceDamping: m, timeConstant: 750, restDelta: 1, restSpeed: 10 }, a), v);
          return n.startAxisValueAnimation(d, y);
        }
      });
      return Promise.all(f).then(l);
    }, t.prototype.startAxisValueAnimation = function(e, n) {
      var r = this.getAxisMotionValue(e);
      return Cn(e, r, 0, n);
    }, t.prototype.stopAnimation = function() {
      var e = this;
      tt(function(n) {
        return e.getAxisMotionValue(n).stop();
      });
    }, t.prototype.getAxisMotionValue = function(e) {
      var n, r, i = "_drag" + e.toUpperCase(), s = this.visualElement.getProps()[i];
      return s || this.visualElement.getValue(e, (r = (n = this.visualElement.getProps().initial) === null || n === void 0 ? void 0 : n[e]) !== null && r !== void 0 ? r : 0);
    }, t.prototype.snapToCursor = function(e) {
      var n = this;
      tt(function(r) {
        var i = n.getProps().drag;
        if (oe(r, i, n.currentDirection)) {
          var s = n.visualElement.projection, o = n.getAxisMotionValue(r);
          if (s && s.layout) {
            var a = s.layout.actual[r], u = a.min, l = a.max;
            o.set(e[r] - O(u, l, 0.5));
          }
        }
      });
    }, t.prototype.scalePositionWithinConstraints = function() {
      var e = this, n, r = this.getProps(), i = r.drag, s = r.dragConstraints, o = this.visualElement.projection;
      if (!(!Pt(s) || !o || !this.constraints)) {
        this.stopAnimation();
        var a = { x: 0, y: 0 };
        tt(function(l) {
          var c = e.getAxisMotionValue(l);
          if (c) {
            var f = c.get();
            a[l] = Fu({ min: f, max: f }, e.constraints[l]);
          }
        });
        var u = this.visualElement.getProps().transformTemplate;
        this.visualElement.getInstance().style.transform = u ? u({}, "") : "none", (n = o.root) === null || n === void 0 || n.updateScroll(), o.updateLayout(), this.resolveConstraints(), tt(function(l) {
          if (oe(l, i, null)) {
            var c = e.getAxisMotionValue(l), f = e.constraints[l], d = f.min, p = f.max;
            c.set(O(d, p, a[l]));
          }
        });
      }
    }, t.prototype.addListeners = function() {
      var e = this, n;
      Ku.set(this.visualElement, this);
      var r = this.visualElement.getInstance(), i = xt(r, "pointerdown", function(l) {
        var c = e.getProps(), f = c.drag, d = c.dragListener, p = d === void 0 ? !0 : d;
        f && p && e.start(l);
      }), s = function() {
        var l = e.getProps().dragConstraints;
        Pt(l) && (e.constraints = e.resolveRefConstraints());
      }, o = this.visualElement.projection, a = o.addEventListener("measure", s);
      o && !o.layout && ((n = o.root) === null || n === void 0 || n.updateScroll(), o.updateLayout()), s();
      var u = Ve(window, "resize", function() {
        return e.scalePositionWithinConstraints();
      });
      return o.addEventListener("didUpdate", function(l) {
        var c = l.delta, f = l.hasLayoutChanged;
        e.isDragging && f && (tt(function(d) {
          var p = e.getAxisMotionValue(d);
          p && (e.originPoint[d] += c[d].translate, p.set(p.get() + c[d].translate));
        }), e.visualElement.syncRender());
      }), function() {
        u(), i(), a();
      };
    }, t.prototype.getProps = function() {
      var e = this.visualElement.getProps(), n = e.drag, r = n === void 0 ? !1 : n, i = e.dragDirectionLock, s = i === void 0 ? !1 : i, o = e.dragPropagation, a = o === void 0 ? !1 : o, u = e.dragConstraints, l = u === void 0 ? !1 : u, c = e.dragElastic, f = c === void 0 ? tn : c, d = e.dragMomentum, p = d === void 0 ? !0 : d;
      return g(g({}, e), { drag: r, dragDirectionLock: s, dragPropagation: a, dragConstraints: l, dragElastic: f, dragMomentum: p });
    }, t;
  }()
);
function oe(t, e, n) {
  return (e === !0 || e === t) && (n === null || n === t);
}
function Wu(t, e) {
  e === void 0 && (e = 10);
  var n = null;
  return Math.abs(t.y) > e ? n = "y" : Math.abs(t.x) > e && (n = "x"), n;
}
function Yu(t) {
  var e = t.dragControls, n = t.visualElement, r = $t(function() {
    return new Gu(n);
  });
  W(function() {
    return e && e.subscribe(r);
  }, [r, e]), W(function() {
    return r.addListeners();
  }, [r]);
}
function $u(t) {
  var e = t.onPan, n = t.onPanStart, r = t.onPanEnd, i = t.onPanSessionStart, s = t.visualElement, o = e || n || r || i, a = et(null), u = j(sn).transformPagePoint, l = {
    onSessionStart: i,
    onStart: n,
    onMove: e,
    onEnd: function(f, d) {
      a.current = null, r && r(f, d);
    }
  };
  W(function() {
    a.current !== null && a.current.updateHandlers(l);
  });
  function c(f) {
    a.current = new Xi(f, l, {
      transformPagePoint: u
    });
  }
  pe(s, "pointerdown", o && c), gn(function() {
    return a.current && a.current.end();
  });
}
var Xu = {
  pan: dt($u),
  drag: dt(Yu)
}, ae = [
  "LayoutMeasure",
  "BeforeLayoutMeasure",
  "LayoutUpdate",
  "ViewportBoxUpdate",
  "Update",
  "Render",
  "AnimationComplete",
  "LayoutAnimationComplete",
  "AnimationStart",
  "LayoutAnimationStart",
  "SetAxisTarget",
  "Unmount"
];
function Zu() {
  var t = ae.map(function() {
    return new Ft();
  }), e = {}, n = {
    clearAllListeners: function() {
      return t.forEach(function(r) {
        return r.clear();
      });
    },
    updatePropListeners: function(r) {
      ae.forEach(function(i) {
        var s, o = "on" + i, a = r[o];
        (s = e[i]) === null || s === void 0 || s.call(e), a && (e[i] = n[o](a));
      });
    }
  };
  return t.forEach(function(r, i) {
    n["on" + ae[i]] = function(s) {
      return r.add(s);
    }, n["notify" + ae[i]] = function() {
      for (var s = [], o = 0; o < arguments.length; o++)
        s[o] = arguments[o];
      return r.notify.apply(r, J([], I(s), !1));
    };
  }), n;
}
function qu(t, e, n) {
  var r;
  for (var i in e) {
    var s = e[i], o = n[i];
    if (it(s))
      t.addValue(i, s), process.env.NODE_ENV === "development" && ki(s.version === "6.5.1", "Attempting to mix Framer Motion versions ".concat(s.version, " with 6.5.1 may not work as expected."));
    else if (it(o))
      t.addValue(i, wt(s));
    else if (o !== s)
      if (t.hasValue(i)) {
        var a = t.getValue(i);
        !a.hasAnimated && a.set(s);
      } else
        t.addValue(i, wt((r = t.getStaticValue(i)) !== null && r !== void 0 ? r : s));
  }
  for (var i in n)
    e[i] === void 0 && t.removeValue(i);
  return e;
}
var eo = function(t) {
  var e = t.treeType, n = e === void 0 ? "" : e, r = t.build, i = t.getBaseTarget, s = t.makeTargetAnimatable, o = t.measureViewportBox, a = t.render, u = t.readValueFromInstance, l = t.removeValueFromRenderState, c = t.sortNodePosition, f = t.scrapeMotionValuesFromProps;
  return function(d, p) {
    var v = d.parent, h = d.props, m = d.presenceId, y = d.blockInitialAnimation, P = d.visualState, b = d.shouldReduceMotion;
    p === void 0 && (p = {});
    var T = !1, S = P.latestValues, E = P.renderState, M, A = Zu(), C = /* @__PURE__ */ new Map(), L = /* @__PURE__ */ new Map(), H = {}, F = g({}, S), _;
    function z() {
      !M || !T || (X(), a(M, E, h.style, R.projection));
    }
    function X() {
      r(R, E, S, p, h);
    }
    function st() {
      A.notifyUpdate(S);
    }
    function K(x, V) {
      var N = V.onChange(function(te) {
        S[x] = te, h.onUpdate && Q.update(st, !1, !0);
      }), Mt = V.onRenderRequest(R.scheduleRender);
      L.set(x, function() {
        N(), Mt();
      });
    }
    var Et = f(h);
    for (var gt in Et) {
      var Qt = Et[gt];
      S[gt] !== void 0 && it(Qt) && Qt.set(S[gt], !1);
    }
    var yt = Se(h), k = Gr(h), R = g(g({
      treeType: n,
      /**
       * This is a mirror of the internal instance prop, which keeps
       * VisualElement type-compatible with React's RefObject.
       */
      current: null,
      /**
       * The depth of this visual element within the visual element tree.
       */
      depth: v ? v.depth + 1 : 0,
      parent: v,
      children: /* @__PURE__ */ new Set(),
      /**
       *
       */
      presenceId: m,
      shouldReduceMotion: b,
      /**
       * If this component is part of the variant tree, it should track
       * any children that are also part of the tree. This is essentially
       * a shadow tree to simplify logic around how to stagger over children.
       */
      variantChildren: k ? /* @__PURE__ */ new Set() : void 0,
      /**
       * Whether this instance is visible. This can be changed imperatively
       * by the projection tree, is analogous to CSS's visibility in that
       * hidden elements should take up layout, and needs enacting by the configured
       * render function.
       */
      isVisible: void 0,
      /**
       * Normally, if a component is controlled by a parent's variants, it can
       * rely on that ancestor to trigger animations further down the tree.
       * However, if a component is created after its parent is mounted, the parent
       * won't trigger that mount animation so the child needs to.
       *
       * TODO: This might be better replaced with a method isParentMounted
       */
      manuallyAnimateOnMount: !!(v != null && v.isMounted()),
      /**
       * This can be set by AnimatePresence to force components that mount
       * at the same time as it to mount as if they have initial={false} set.
       */
      blockInitialAnimation: y,
      /**
       * Determine whether this component has mounted yet. This is mostly used
       * by variant children to determine whether they need to trigger their
       * own animations on mount.
       */
      isMounted: function() {
        return !!M;
      },
      mount: function(x) {
        T = !0, M = R.current = x, R.projection && R.projection.mount(x), k && v && !yt && (_ = v == null ? void 0 : v.addVariantChild(R)), C.forEach(function(V, N) {
          return K(N, V);
        }), v == null || v.children.add(R), R.setProps(h);
      },
      /**
       *
       */
      unmount: function() {
        var x;
        (x = R.projection) === null || x === void 0 || x.unmount(), Vt.update(st), Vt.render(z), L.forEach(function(V) {
          return V();
        }), _ == null || _(), v == null || v.children.delete(R), A.clearAllListeners(), M = void 0, T = !1;
      },
      /**
       * Add a child visual element to our set of children.
       */
      addVariantChild: function(x) {
        var V, N = R.getClosestVariantNode();
        if (N)
          return (V = N.variantChildren) === null || V === void 0 || V.add(x), function() {
            return N.variantChildren.delete(x);
          };
      },
      sortNodePosition: function(x) {
        return !c || n !== x.treeType ? 0 : c(R.getInstance(), x.getInstance());
      },
      /**
       * Returns the closest variant node in the tree starting from
       * this visual element.
       */
      getClosestVariantNode: function() {
        return k ? R : v == null ? void 0 : v.getClosestVariantNode();
      },
      /**
       * Expose the latest layoutId prop.
       */
      getLayoutId: function() {
        return h.layoutId;
      },
      /**
       * Returns the current instance.
       */
      getInstance: function() {
        return M;
      },
      /**
       * Get/set the latest static values.
       */
      getStaticValue: function(x) {
        return S[x];
      },
      setStaticValue: function(x, V) {
        return S[x] = V;
      },
      /**
       * Returns the latest motion value state. Currently only used to take
       * a snapshot of the visual element - perhaps this can return the whole
       * visual state
       */
      getLatestValues: function() {
        return S;
      },
      /**
       * Set the visiblity of the visual element. If it's changed, schedule
       * a render to reflect these changes.
       */
      setVisibility: function(x) {
        R.isVisible !== x && (R.isVisible = x, R.scheduleRender());
      },
      /**
       * Make a target animatable by Popmotion. For instance, if we're
       * trying to animate width from 100px to 100vw we need to measure 100vw
       * in pixels to determine what we really need to animate to. This is also
       * pluggable to support Framer's custom value types like Color,
       * and CSS variables.
       */
      makeTargetAnimatable: function(x, V) {
        return V === void 0 && (V = !0), s(R, x, h, V);
      },
      /**
       * Measure the current viewport box with or without transforms.
       * Only measures axis-aligned boxes, rotate and skew must be manually
       * removed with a re-render to work.
       */
      measureViewportBox: function() {
        return o(M, h);
      },
      // Motion values ========================
      /**
       * Add a motion value and bind it to this visual element.
       */
      addValue: function(x, V) {
        R.hasValue(x) && R.removeValue(x), C.set(x, V), S[x] = V.get(), K(x, V);
      },
      /**
       * Remove a motion value and unbind any active subscriptions.
       */
      removeValue: function(x) {
        var V;
        C.delete(x), (V = L.get(x)) === null || V === void 0 || V(), L.delete(x), delete S[x], l(x, E);
      },
      /**
       * Check whether we have a motion value for this key
       */
      hasValue: function(x) {
        return C.has(x);
      },
      /**
       * Get a motion value for this key. If called with a default
       * value, we'll create one if none exists.
       */
      getValue: function(x, V) {
        var N = C.get(x);
        return N === void 0 && V !== void 0 && (N = wt(V), R.addValue(x, N)), N;
      },
      /**
       * Iterate over our motion values.
       */
      forEachValue: function(x) {
        return C.forEach(x);
      },
      /**
       * If we're trying to animate to a previously unencountered value,
       * we need to check for it in our state and as a last resort read it
       * directly from the instance (which might have performance implications).
       */
      readValue: function(x) {
        var V;
        return (V = S[x]) !== null && V !== void 0 ? V : u(M, x, p);
      },
      /**
       * Set the base target to later animate back to. This is currently
       * only hydrated on creation and when we first read a value.
       */
      setBaseTarget: function(x, V) {
        F[x] = V;
      },
      /**
       * Find the base target for a value thats been removed from all animation
       * props.
       */
      getBaseTarget: function(x) {
        if (i) {
          var V = i(h, x);
          if (V !== void 0 && !it(V))
            return V;
        }
        return F[x];
      }
    }, A), {
      /**
       * Build the renderer state based on the latest visual state.
       */
      build: function() {
        return X(), E;
      },
      /**
       * Schedule a render on the next animation frame.
       */
      scheduleRender: function() {
        Q.render(z, !1, !0);
      },
      /**
       * Synchronously fire render. It's prefered that we batch renders but
       * in many circumstances, like layout measurement, we need to run this
       * synchronously. However in those instances other measures should be taken
       * to batch reads/writes.
       */
      syncRender: z,
      /**
       * Update the provided props. Ensure any newly-added motion values are
       * added to our map, old ones removed, and listeners updated.
       */
      setProps: function(x) {
        (x.transformTemplate || h.transformTemplate) && R.scheduleRender(), h = x, A.updatePropListeners(x), H = qu(R, f(h), H);
      },
      getProps: function() {
        return h;
      },
      // Variants ==============================
      /**
       * Returns the variant definition with a given name.
       */
      getVariant: function(x) {
        var V;
        return (V = h.variants) === null || V === void 0 ? void 0 : V[x];
      },
      /**
       * Returns the defined default transition on this component.
       */
      getDefaultTransition: function() {
        return h.transition;
      },
      getTransformPagePoint: function() {
        return h.transformPagePoint;
      },
      /**
       * Used by child variant nodes to get the closest ancestor variant props.
       */
      getVariantContext: function(x) {
        if (x === void 0 && (x = !1), x)
          return v == null ? void 0 : v.getVariantContext();
        if (!yt) {
          var V = (v == null ? void 0 : v.getVariantContext()) || {};
          return h.initial !== void 0 && (V.initial = h.initial), V;
        }
        for (var N = {}, Mt = 0; Mt < Ju; Mt++) {
          var te = no[Mt], Ee = h[te];
          (q(Ee) || Ee === !1) && (N[te] = Ee);
        }
        return N;
      }
    });
    return R;
  };
}, no = J(["initial"], I(Rn), !1), Ju = no.length;
function nn(t) {
  return typeof t == "string" && t.startsWith("var(--");
}
var ro = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function Qu(t) {
  var e = ro.exec(t);
  if (!e)
    return [,];
  var n = I(e, 3), r = n[1], i = n[2];
  return [r, i];
}
var tl = 4;
function rn(t, e, n) {
  n === void 0 && (n = 1), Y(n <= tl, 'Max CSS variable fallback depth detected in property "'.concat(t, '". This may indicate a circular fallback dependency.'));
  var r = I(Qu(t), 2), i = r[0], s = r[1];
  if (i) {
    var o = window.getComputedStyle(e).getPropertyValue(i);
    return o ? o.trim() : nn(s) ? rn(s, e, n + 1) : s;
  }
}
function el(t, e, n) {
  var r, i = $(e, []), s = t.getInstance();
  if (!(s instanceof Element))
    return { target: i, transitionEnd: n };
  n && (n = g({}, n)), t.forEachValue(function(l) {
    var c = l.get();
    if (nn(c)) {
      var f = rn(c, s);
      f && l.set(f);
    }
  });
  for (var o in i) {
    var a = i[o];
    if (nn(a)) {
      var u = rn(a, s);
      u && (i[o] = u, n && ((r = n[o]) !== null && r !== void 0 || (n[o] = a)));
    }
  }
  return { target: i, transitionEnd: n };
}
var nl = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y"
]), io = function(t) {
  return nl.has(t);
}, rl = function(t) {
  return Object.keys(t).some(io);
}, oo = function(t, e) {
  t.set(e, !1), t.set(e);
}, se = function(t) {
  return t === mt || t === w;
}, gr;
(function(t) {
  t.width = "width", t.height = "height", t.left = "left", t.right = "right", t.top = "top", t.bottom = "bottom";
})(gr || (gr = {}));
var yr = function(t, e) {
  return parseFloat(t.split(", ")[e]);
}, br = function(t, e) {
  return function(n, r) {
    var i = r.transform;
    if (i === "none" || !i)
      return 0;
    var s = i.match(/^matrix3d\((.+)\)$/);
    if (s)
      return yr(s[1], e);
    var o = i.match(/^matrix\((.+)\)$/);
    return o ? yr(o[1], t) : 0;
  };
}, il = /* @__PURE__ */ new Set(["x", "y", "z"]), ol = Ht.filter(function(t) {
  return !il.has(t);
});
function al(t) {
  var e = [];
  return ol.forEach(function(n) {
    var r = t.getValue(n);
    r !== void 0 && (e.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
  }), e.length && t.syncRender(), e;
}
var Pr = {
  // Dimensions
  width: function(t, e) {
    var n = t.x, r = e.paddingLeft, i = r === void 0 ? "0" : r, s = e.paddingRight, o = s === void 0 ? "0" : s;
    return n.max - n.min - parseFloat(i) - parseFloat(o);
  },
  height: function(t, e) {
    var n = t.y, r = e.paddingTop, i = r === void 0 ? "0" : r, s = e.paddingBottom, o = s === void 0 ? "0" : s;
    return n.max - n.min - parseFloat(i) - parseFloat(o);
  },
  top: function(t, e) {
    var n = e.top;
    return parseFloat(n);
  },
  left: function(t, e) {
    var n = e.left;
    return parseFloat(n);
  },
  bottom: function(t, e) {
    var n = t.y, r = e.top;
    return parseFloat(r) + (n.max - n.min);
  },
  right: function(t, e) {
    var n = t.x, r = e.left;
    return parseFloat(r) + (n.max - n.min);
  },
  // Transform
  x: br(4, 13),
  y: br(5, 14)
}, sl = function(t, e, n) {
  var r = e.measureViewportBox(), i = e.getInstance(), s = getComputedStyle(i), o = s.display, a = {};
  o === "none" && e.setStaticValue("display", t.display || "block"), n.forEach(function(l) {
    a[l] = Pr[l](r, s);
  }), e.syncRender();
  var u = e.measureViewportBox();
  return n.forEach(function(l) {
    var c = e.getValue(l);
    oo(c, a[l]), t[l] = Pr[l](u, s);
  }), t;
}, ul = function(t, e, n, r) {
  n === void 0 && (n = {}), r === void 0 && (r = {}), e = g({}, e), r = g({}, r);
  var i = Object.keys(e).filter(io), s = [], o = !1, a = [];
  if (i.forEach(function(c) {
    var f = t.getValue(c);
    if (t.hasValue(c)) {
      var d = n[c], p = Rt(d), v = e[c], h;
      if (zt(v)) {
        var m = v.length, y = v[0] === null ? 1 : 0;
        d = v[y], p = Rt(d);
        for (var P = y; P < m; P++)
          h ? Y(Rt(v[P]) === h, "All keyframes must be of the same type") : (h = Rt(v[P]), Y(h === p || se(p) && se(h), "Keyframes must be of the same dimension as the current value"));
      } else
        h = Rt(v);
      if (p !== h)
        if (se(p) && se(h)) {
          var b = f.get();
          typeof b == "string" && f.set(parseFloat(b)), typeof v == "string" ? e[c] = parseFloat(v) : Array.isArray(v) && h === w && (e[c] = v.map(parseFloat));
        } else
          p != null && p.transform && (h != null && h.transform) && (d === 0 || v === 0) ? d === 0 ? f.set(h.transform(d)) : e[c] = p.transform(v) : (o || (s = al(t), o = !0), a.push(c), r[c] = r[c] !== void 0 ? r[c] : e[c], oo(f, v));
    }
  }), a.length) {
    var u = a.indexOf("height") >= 0 ? window.pageYOffset : null, l = sl(e, t, a);
    return s.length && s.forEach(function(c) {
      var f = I(c, 2), d = f[0], p = f[1];
      t.getValue(d).set(p);
    }), t.syncRender(), u !== null && window.scrollTo({ top: u }), { target: l, transitionEnd: r };
  } else
    return { target: e, transitionEnd: r };
};
function ll(t, e, n, r) {
  return rl(e) ? ul(t, e, n, r) : { target: e, transitionEnd: r };
}
var cl = function(t, e, n, r) {
  var i = el(t, e, r);
  return e = i.target, r = i.transitionEnd, ll(t, e, n, r);
};
function fl(t) {
  return window.getComputedStyle(t);
}
var ao = {
  treeType: "dom",
  readValueFromInstance: function(t, e) {
    if (Xt(e)) {
      var n = Vn(e);
      return n && n.default || 0;
    } else {
      var r = fl(t);
      return (Xr(e) ? r.getPropertyValue(e) : r[e]) || 0;
    }
  },
  sortNodePosition: function(t, e) {
    return t.compareDocumentPosition(e) & 2 ? 1 : -1;
  },
  getBaseTarget: function(t, e) {
    var n;
    return (n = t.style) === null || n === void 0 ? void 0 : n[e];
  },
  measureViewportBox: function(t, e) {
    var n = e.transformPagePoint;
    return to(t, n);
  },
  /**
   * Reset the transform on the current Element. This is called as part
   * of a batched process across the entire layout tree. To remove this write
   * cycle it'd be interesting to see if it's possible to "undo" all the current
   * layout transforms up the tree in the same way this.getBoundingBoxWithoutTransforms
   * works
   */
  resetTransform: function(t, e, n) {
    var r = n.transformTemplate;
    e.style.transform = r ? r({}, "") : "none", t.scheduleRender();
  },
  restoreTransform: function(t, e) {
    t.style.transform = e.style.transform;
  },
  removeValueFromRenderState: function(t, e) {
    var n = e.vars, r = e.style;
    delete n[t], delete r[t];
  },
  /**
   * Ensure that HTML and Framer-specific value types like `px`->`%` and `Color`
   * can be animated by Motion.
   */
  makeTargetAnimatable: function(t, e, n, r) {
    var i = n.transformValues;
    r === void 0 && (r = !0);
    var s = e.transition, o = e.transitionEnd, a = $(e, ["transition", "transitionEnd"]), u = gu(a, s || {}, t);
    if (i && (o && (o = i(o)), a && (a = i(a)), u && (u = i(u))), r) {
      hu(t, a, u);
      var l = cl(t, a, u, o);
      o = l.transitionEnd, a = l.target;
    }
    return g({ transition: s, transitionEnd: o }, a);
  },
  scrapeMotionValuesFromProps: pn,
  build: function(t, e, n, r, i) {
    t.isVisible !== void 0 && (e.style.visibility = t.isVisible ? "visible" : "hidden"), fn(e, n, r, i.transformTemplate);
  },
  render: ui
}, dl = eo(ao), vl = eo(g(g({}, ao), { getBaseTarget: function(t, e) {
  return t[e];
}, readValueFromInstance: function(t, e) {
  var n;
  return Xt(e) ? ((n = Vn(e)) === null || n === void 0 ? void 0 : n.default) || 0 : (e = li.has(e) ? e : si(e), t.getAttribute(e));
}, scrapeMotionValuesFromProps: fi, build: function(t, e, n, r, i) {
  vn(e, n, r, i.transformTemplate);
}, render: ci })), pl = function(t, e) {
  return ln(t) ? vl(e, { enableHardwareAcceleration: !1 }) : dl(e, { enableHardwareAcceleration: !0 });
};
function Tr(t, e) {
  return e.max === e.min ? 0 : t / (e.max - e.min) * 100;
}
var Lt = {
  correct: function(t, e) {
    if (!e.target)
      return t;
    if (typeof t == "string")
      if (w.test(t))
        t = parseFloat(t);
      else
        return t;
    var n = Tr(t, e.target.x), r = Tr(t, e.target.y);
    return "".concat(n, "% ").concat(r, "%");
  }
}, xr = "_$css", hl = {
  correct: function(t, e) {
    var n = e.treeScale, r = e.projectionDelta, i = t, s = t.includes("var("), o = [];
    s && (t = t.replace(ro, function(h) {
      return o.push(h), xr;
    }));
    var a = ot.parse(t);
    if (a.length > 5)
      return i;
    var u = ot.createTransformer(t), l = typeof a[0] != "number" ? 1 : 0, c = r.x.scale * n.x, f = r.y.scale * n.y;
    a[0 + l] /= c, a[1 + l] /= f;
    var d = O(c, f, 0.5);
    typeof a[2 + l] == "number" && (a[2 + l] /= d), typeof a[3 + l] == "number" && (a[3 + l] /= d);
    var p = u(a);
    if (s) {
      var v = 0;
      p = p.replace(xr, function() {
        var h = o[v];
        return v++, h;
      });
    }
    return p;
  }
}, ml = (
  /** @class */
  function(t) {
    _r(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.componentDidMount = function() {
      var n = this, r = this.props, i = r.visualElement, s = r.layoutGroup, o = r.switchLayoutGroup, a = r.layoutId, u = i.projection;
      ko(yl), u && (s != null && s.group && s.group.add(u), o != null && o.register && a && o.register(u), u.root.didUpdate(), u.addEventListener("animationComplete", function() {
        n.safeToRemove();
      }), u.setOptions(g(g({}, u.options), { onExitComplete: function() {
        return n.safeToRemove();
      } }))), Dt.hasEverUpdated = !0;
    }, e.prototype.getSnapshotBeforeUpdate = function(n) {
      var r = this, i = this.props, s = i.layoutDependency, o = i.visualElement, a = i.drag, u = i.isPresent, l = o.projection;
      return l && (l.isPresent = u, a || n.layoutDependency !== s || s === void 0 ? l.willUpdate() : this.safeToRemove(), n.isPresent !== u && (u ? l.promote() : l.relegate() || Q.postRender(function() {
        var c;
        !((c = l.getStack()) === null || c === void 0) && c.members.length || r.safeToRemove();
      }))), null;
    }, e.prototype.componentDidUpdate = function() {
      var n = this.props.visualElement.projection;
      n && (n.root.didUpdate(), !n.currentAnimation && n.isLead() && this.safeToRemove());
    }, e.prototype.componentWillUnmount = function() {
      var n = this.props, r = n.visualElement, i = n.layoutGroup, s = n.switchLayoutGroup, o = r.projection;
      o && (o.scheduleCheckAfterUnmount(), i != null && i.group && i.group.remove(o), s != null && s.deregister && s.deregister(o));
    }, e.prototype.safeToRemove = function() {
      var n = this.props.safeToRemove;
      n == null || n();
    }, e.prototype.render = function() {
      return null;
    }, e;
  }(on.Component)
);
function gl(t) {
  var e = I(Ki(), 2), n = e[0], r = e[1], i = j(un);
  return on.createElement(ml, g({}, t, { layoutGroup: i, switchLayoutGroup: j(Wr), isPresent: n, safeToRemove: r }));
}
var yl = {
  borderRadius: g(g({}, Lt), { applyTo: [
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderBottomLeftRadius",
    "borderBottomRightRadius"
  ] }),
  borderTopLeftRadius: Lt,
  borderTopRightRadius: Lt,
  borderBottomLeftRadius: Lt,
  borderBottomRightRadius: Lt,
  boxShadow: hl
}, bl = {
  measureLayout: gl
};
function Pl(t, e, n) {
  n === void 0 && (n = {});
  var r = it(t) ? t : wt(t);
  return Cn("", r, e, n), {
    stop: function() {
      return r.stop();
    },
    isAnimating: function() {
      return r.isAnimating();
    }
  };
}
var so = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], Tl = so.length, Sr = function(t) {
  return typeof t == "string" ? parseFloat(t) : t;
}, Vr = function(t) {
  return typeof t == "number" || w.test(t);
};
function xl(t, e, n, r, i, s) {
  var o, a, u, l;
  i ? (t.opacity = O(
    0,
    // (follow?.opacity as number) ?? 0,
    // TODO Reinstate this if only child
    (o = n.opacity) !== null && o !== void 0 ? o : 1,
    Sl(r)
  ), t.opacityExit = O((a = e.opacity) !== null && a !== void 0 ? a : 1, 0, Vl(r))) : s && (t.opacity = O((u = e.opacity) !== null && u !== void 0 ? u : 1, (l = n.opacity) !== null && l !== void 0 ? l : 1, r));
  for (var c = 0; c < Tl; c++) {
    var f = "border".concat(so[c], "Radius"), d = wr(e, f), p = wr(n, f);
    if (!(d === void 0 && p === void 0)) {
      d || (d = 0), p || (p = 0);
      var v = d === 0 || p === 0 || Vr(d) === Vr(p);
      v ? (t[f] = Math.max(O(Sr(d), Sr(p), r), 0), (nt.test(p) || nt.test(d)) && (t[f] += "%")) : t[f] = p;
    }
  }
  (e.rotate || n.rotate) && (t.rotate = O(e.rotate || 0, n.rotate || 0, r));
}
function wr(t, e) {
  var n;
  return (n = t[e]) !== null && n !== void 0 ? n : t.borderRadius;
}
var Sl = uo(0, 0.5, xn), Vl = uo(0.5, 0.95, Pn);
function uo(t, e, n) {
  return function(r) {
    return r < t ? 0 : r > e ? 1 : n(Kt(t, e, r));
  };
}
function Ar(t, e) {
  t.min = e.min, t.max = e.max;
}
function Z(t, e) {
  Ar(t.x, e.x), Ar(t.y, e.y);
}
function Cr(t, e, n, r, i) {
  return t -= e, t = Pe(t, 1 / n, r), i !== void 0 && (t = Pe(t, 1 / i, r)), t;
}
function wl(t, e, n, r, i, s, o) {
  if (e === void 0 && (e = 0), n === void 0 && (n = 1), r === void 0 && (r = 0.5), s === void 0 && (s = t), o === void 0 && (o = t), nt.test(e)) {
    e = parseFloat(e);
    var a = O(o.min, o.max, e / 100);
    e = a - o.min;
  }
  if (typeof e == "number") {
    var u = O(s.min, s.max, r);
    t === s && (u -= e), t.min = Cr(t.min, e, n, u, i), t.max = Cr(t.max, e, n, u, i);
  }
}
function Er(t, e, n, r, i) {
  var s = I(n, 3), o = s[0], a = s[1], u = s[2];
  wl(t, e[o], e[a], e[u], e.scale, r, i);
}
var Al = ["x", "scaleX", "originX"], Cl = ["y", "scaleY", "originY"];
function Mr(t, e, n, r) {
  Er(t.x, e, Al, n == null ? void 0 : n.x, r == null ? void 0 : r.x), Er(t.y, e, Cl, n == null ? void 0 : n.y, r == null ? void 0 : r.y);
}
function Rr(t) {
  return t.translate === 0 && t.scale === 1;
}
function lo(t) {
  return Rr(t.x) && Rr(t.y);
}
function co(t, e) {
  return t.x.min === e.x.min && t.x.max === e.x.max && t.y.min === e.y.min && t.y.max === e.y.max;
}
var El = (
  /** @class */
  function() {
    function t() {
      this.members = [];
    }
    return t.prototype.add = function(e) {
      En(this.members, e), e.scheduleRender();
    }, t.prototype.remove = function(e) {
      if (Mn(this.members, e), e === this.prevLead && (this.prevLead = void 0), e === this.lead) {
        var n = this.members[this.members.length - 1];
        n && this.promote(n);
      }
    }, t.prototype.relegate = function(e) {
      var n = this.members.findIndex(function(o) {
        return e === o;
      });
      if (n === 0)
        return !1;
      for (var r, i = n; i >= 0; i--) {
        var s = this.members[i];
        if (s.isPresent !== !1) {
          r = s;
          break;
        }
      }
      return r ? (this.promote(r), !0) : !1;
    }, t.prototype.promote = function(e, n) {
      var r, i = this.lead;
      if (e !== i && (this.prevLead = i, this.lead = e, e.show(), i)) {
        i.instance && i.scheduleRender(), e.scheduleRender(), e.resumeFrom = i, n && (e.resumeFrom.preserveOpacity = !0), i.snapshot && (e.snapshot = i.snapshot, e.snapshot.latestValues = i.animationValues || i.latestValues, e.snapshot.isShared = !0), !((r = e.root) === null || r === void 0) && r.isUpdating && (e.isLayoutDirty = !0);
        var s = e.options.crossfade;
        s === !1 && i.hide();
      }
    }, t.prototype.exitAnimationComplete = function() {
      this.members.forEach(function(e) {
        var n, r, i, s, o;
        (r = (n = e.options).onExitComplete) === null || r === void 0 || r.call(n), (o = (i = e.resumingFrom) === null || i === void 0 ? void 0 : (s = i.options).onExitComplete) === null || o === void 0 || o.call(s);
      });
    }, t.prototype.scheduleRender = function() {
      this.members.forEach(function(e) {
        e.instance && e.scheduleRender(!1);
      });
    }, t.prototype.removeLeadSnapshot = function() {
      this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
    }, t;
  }()
), Ml = "translate3d(0px, 0px, 0) scale(1, 1) scale(1, 1)";
function Lr(t, e, n) {
  var r = t.x.translate / e.x, i = t.y.translate / e.y, s = "translate3d(".concat(r, "px, ").concat(i, "px, 0) ");
  if (s += "scale(".concat(1 / e.x, ", ").concat(1 / e.y, ") "), n) {
    var o = n.rotate, a = n.rotateX, u = n.rotateY;
    o && (s += "rotate(".concat(o, "deg) ")), a && (s += "rotateX(".concat(a, "deg) ")), u && (s += "rotateY(".concat(u, "deg) "));
  }
  var l = t.x.scale * e.x, c = t.y.scale * e.y;
  return s += "scale(".concat(l, ", ").concat(c, ")"), s === Ml ? "none" : s;
}
var Rl = function(t, e) {
  return t.depth - e.depth;
}, Ll = (
  /** @class */
  function() {
    function t() {
      this.children = [], this.isDirty = !1;
    }
    return t.prototype.add = function(e) {
      En(this.children, e), this.isDirty = !0;
    }, t.prototype.remove = function(e) {
      Mn(this.children, e), this.isDirty = !0;
    }, t.prototype.forEach = function(e) {
      this.isDirty && this.children.sort(Rl), this.isDirty = !1, this.children.forEach(e);
    }, t;
  }()
), Dr = 1e3;
function fo(t) {
  var e = t.attachResizeListener, n = t.defaultParent, r = t.measureScroll, i = t.checkIsScrollRoot, s = t.resetTransform;
  return (
    /** @class */
    function() {
      function o(a, u, l) {
        var c = this;
        u === void 0 && (u = {}), l === void 0 && (l = n == null ? void 0 : n()), this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.potentialNodes = /* @__PURE__ */ new Map(), this.checkUpdateFailed = function() {
          c.isUpdating && (c.isUpdating = !1, c.clearAllSnapshots());
        }, this.updateProjection = function() {
          c.nodes.forEach(Bl), c.nodes.forEach(_l);
        }, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.id = a, this.latestValues = u, this.root = l ? l.root || l : this, this.path = l ? J(J([], I(l.path), !1), [l], !1) : [], this.parent = l, this.depth = l ? l.depth + 1 : 0, a && this.root.registerPotentialNode(a, this);
        for (var f = 0; f < this.path.length; f++)
          this.path[f].shouldResetTransform = !0;
        this.root === this && (this.nodes = new Ll());
      }
      return o.prototype.addEventListener = function(a, u) {
        return this.eventHandlers.has(a) || this.eventHandlers.set(a, new Ft()), this.eventHandlers.get(a).add(u);
      }, o.prototype.notifyListeners = function(a) {
        for (var u = [], l = 1; l < arguments.length; l++)
          u[l - 1] = arguments[l];
        var c = this.eventHandlers.get(a);
        c == null || c.notify.apply(c, J([], I(u), !1));
      }, o.prototype.hasListeners = function(a) {
        return this.eventHandlers.has(a);
      }, o.prototype.registerPotentialNode = function(a, u) {
        this.potentialNodes.set(a, u);
      }, o.prototype.mount = function(a, u) {
        var l = this, c;
        if (u === void 0 && (u = !1), !this.instance) {
          this.isSVG = a instanceof SVGElement && a.tagName !== "svg", this.instance = a;
          var f = this.options, d = f.layoutId, p = f.layout, v = f.visualElement;
          if (v && !v.getInstance() && v.mount(a), this.root.nodes.add(this), (c = this.parent) === null || c === void 0 || c.children.add(this), this.id && this.root.potentialNodes.delete(this.id), u && (p || d) && (this.isLayoutDirty = !0), e) {
            var h, m = function() {
              return l.root.updateBlockedByResize = !1;
            };
            e(a, function() {
              l.root.updateBlockedByResize = !0, clearTimeout(h), h = window.setTimeout(m, 250), Dt.hasAnimatedSinceResize && (Dt.hasAnimatedSinceResize = !1, l.nodes.forEach(jl));
            });
          }
          d && this.root.registerSharedNode(d, this), this.options.animate !== !1 && v && (d || p) && this.addEventListener("didUpdate", function(y) {
            var P, b, T, S, E, M = y.delta, A = y.hasLayoutChanged, C = y.hasRelativeTargetChanged, L = y.layout;
            if (l.isTreeAnimationBlocked()) {
              l.target = void 0, l.relativeTarget = void 0;
              return;
            }
            var H = (b = (P = l.options.transition) !== null && P !== void 0 ? P : v.getDefaultTransition()) !== null && b !== void 0 ? b : zl, F = v.getProps(), _ = F.onLayoutAnimationStart, z = F.onLayoutAnimationComplete, X = !l.targetLayout || !co(l.targetLayout, L) || C, st = !A && C;
            if (!((T = l.resumeFrom) === null || T === void 0) && T.instance || st || A && (X || !l.currentAnimation)) {
              l.resumeFrom && (l.resumingFrom = l.resumeFrom, l.resumingFrom.resumingFrom = void 0), l.setAnimationOrigin(M, st);
              var K = g(g({}, An(H, "layout")), { onPlay: _, onComplete: z });
              v.shouldReduceMotion && (K.delay = 0, K.type = !1), l.startAnimation(K);
            } else
              !A && l.animationProgress === 0 && l.finishAnimation(), l.isLead() && ((E = (S = l.options).onExitComplete) === null || E === void 0 || E.call(S));
            l.targetLayout = L;
          });
        }
      }, o.prototype.unmount = function() {
        var a, u;
        this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this), (a = this.getStack()) === null || a === void 0 || a.remove(this), (u = this.parent) === null || u === void 0 || u.children.delete(this), this.instance = void 0, Vt.preRender(this.updateProjection);
      }, o.prototype.blockUpdate = function() {
        this.updateManuallyBlocked = !0;
      }, o.prototype.unblockUpdate = function() {
        this.updateManuallyBlocked = !1;
      }, o.prototype.isUpdateBlocked = function() {
        return this.updateManuallyBlocked || this.updateBlockedByResize;
      }, o.prototype.isTreeAnimationBlocked = function() {
        var a;
        return this.isAnimationBlocked || ((a = this.parent) === null || a === void 0 ? void 0 : a.isTreeAnimationBlocked()) || !1;
      }, o.prototype.startUpdate = function() {
        var a;
        this.isUpdateBlocked() || (this.isUpdating = !0, (a = this.nodes) === null || a === void 0 || a.forEach(Nl));
      }, o.prototype.willUpdate = function(a) {
        var u, l, c;
        if (a === void 0 && (a = !0), this.root.isUpdateBlocked()) {
          (l = (u = this.options).onExitComplete) === null || l === void 0 || l.call(u);
          return;
        }
        if (!this.root.isUpdating && this.root.startUpdate(), !this.isLayoutDirty) {
          this.isLayoutDirty = !0;
          for (var f = 0; f < this.path.length; f++) {
            var d = this.path[f];
            d.shouldResetTransform = !0, d.updateScroll();
          }
          var p = this.options, v = p.layoutId, h = p.layout;
          if (!(v === void 0 && !h)) {
            var m = (c = this.options.visualElement) === null || c === void 0 ? void 0 : c.getProps().transformTemplate;
            this.prevTransformTemplateValue = m == null ? void 0 : m(this.latestValues, ""), this.updateSnapshot(), a && this.notifyListeners("willUpdate");
          }
        }
      }, o.prototype.didUpdate = function() {
        var a = this.isUpdateBlocked();
        if (a) {
          this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(Or);
          return;
        }
        this.isUpdating && (this.isUpdating = !1, this.potentialNodes.size && (this.potentialNodes.forEach(Kl), this.potentialNodes.clear()), this.nodes.forEach(Fl), this.nodes.forEach(Dl), this.nodes.forEach(Ol), this.clearAllSnapshots(), De.update(), De.preRender(), De.render());
      }, o.prototype.clearAllSnapshots = function() {
        this.nodes.forEach(Il), this.sharedNodes.forEach(Ul);
      }, o.prototype.scheduleUpdateProjection = function() {
        Q.preRender(this.updateProjection, !1, !0);
      }, o.prototype.scheduleCheckAfterUnmount = function() {
        var a = this;
        Q.postRender(function() {
          a.isLayoutDirty ? a.root.didUpdate() : a.root.checkUpdateFailed();
        });
      }, o.prototype.updateSnapshot = function() {
        if (!(this.snapshot || !this.instance)) {
          var a = this.measure(), u = this.removeTransform(this.removeElementScroll(a));
          Br(u), this.snapshot = {
            measured: a,
            layout: u,
            latestValues: {}
          };
        }
      }, o.prototype.updateLayout = function() {
        var a;
        if (this.instance && (this.updateScroll(), !(!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))) {
          if (this.resumeFrom && !this.resumeFrom.instance)
            for (var u = 0; u < this.path.length; u++) {
              var l = this.path[u];
              l.updateScroll();
            }
          var c = this.measure();
          Br(c);
          var f = this.layout;
          this.layout = {
            measured: c,
            actual: this.removeElementScroll(c)
          }, this.layoutCorrected = B(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.actual), (a = this.options.visualElement) === null || a === void 0 || a.notifyLayoutMeasure(this.layout.actual, f == null ? void 0 : f.actual);
        }
      }, o.prototype.updateScroll = function() {
        this.options.layoutScroll && this.instance && (this.isScrollRoot = i(this.instance), this.scroll = r(this.instance));
      }, o.prototype.resetTransform = function() {
        var a;
        if (s) {
          var u = this.isLayoutDirty || this.shouldResetTransform, l = this.projectionDelta && !lo(this.projectionDelta), c = (a = this.options.visualElement) === null || a === void 0 ? void 0 : a.getProps().transformTemplate, f = c == null ? void 0 : c(this.latestValues, ""), d = f !== this.prevTransformTemplateValue;
          u && (l || lt(this.latestValues) || d) && (s(this.instance, f), this.shouldResetTransform = !1, this.scheduleRender());
        }
      }, o.prototype.measure = function() {
        var a = this.options.visualElement;
        if (!a)
          return B();
        var u = a.measureViewportBox(), l = this.root.scroll;
        return l && (ct(u.x, l.x), ct(u.y, l.y)), u;
      }, o.prototype.removeElementScroll = function(a) {
        var u = B();
        Z(u, a);
        for (var l = 0; l < this.path.length; l++) {
          var c = this.path[l], f = c.scroll, d = c.options, p = c.isScrollRoot;
          if (c !== this.root && f && d.layoutScroll) {
            if (p) {
              Z(u, a);
              var v = this.root.scroll;
              v && (ct(u.x, -v.x), ct(u.y, -v.y));
            }
            ct(u.x, f.x), ct(u.y, f.y);
          }
        }
        return u;
      }, o.prototype.applyTransform = function(a, u) {
        u === void 0 && (u = !1);
        var l = B();
        Z(l, a);
        for (var c = 0; c < this.path.length; c++) {
          var f = this.path[c];
          !u && f.options.layoutScroll && f.scroll && f !== f.root && Tt(l, {
            x: -f.scroll.x,
            y: -f.scroll.y
          }), lt(f.latestValues) && Tt(l, f.latestValues);
        }
        return lt(this.latestValues) && Tt(l, this.latestValues), l;
      }, o.prototype.removeTransform = function(a) {
        var u, l = B();
        Z(l, a);
        for (var c = 0; c < this.path.length; c++) {
          var f = this.path[c];
          if (f.instance && lt(f.latestValues)) {
            Ji(f.latestValues) && f.updateSnapshot();
            var d = B(), p = f.measure();
            Z(d, p), Mr(l, f.latestValues, (u = f.snapshot) === null || u === void 0 ? void 0 : u.layout, d);
          }
        }
        return lt(this.latestValues) && Mr(l, this.latestValues), l;
      }, o.prototype.setTargetDelta = function(a) {
        this.targetDelta = a, this.root.scheduleUpdateProjection();
      }, o.prototype.setOptions = function(a) {
        var u;
        this.options = g(g(g({}, this.options), a), { crossfade: (u = a.crossfade) !== null && u !== void 0 ? u : !0 });
      }, o.prototype.clearMeasurements = function() {
        this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
      }, o.prototype.resolveTargetDelta = function() {
        var a, u = this.options, l = u.layout, c = u.layoutId;
        !this.layout || !(l || c) || (!this.targetDelta && !this.relativeTarget && (this.relativeParent = this.getClosestProjectingParent(), this.relativeParent && this.relativeParent.layout && (this.relativeTarget = B(), this.relativeTargetOrigin = B(), Bt(this.relativeTargetOrigin, this.layout.actual, this.relativeParent.layout.actual), Z(this.relativeTarget, this.relativeTargetOrigin))), !(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = B(), this.targetWithTransforms = B()), this.relativeTarget && this.relativeTargetOrigin && (!((a = this.relativeParent) === null || a === void 0) && a.target) ? Lu(this.target, this.relativeTarget, this.relativeParent.target) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.actual) : Z(this.target, this.layout.actual), Qi(this.target, this.targetDelta)) : Z(this.target, this.layout.actual), this.attemptToResolveRelativeTarget && (this.attemptToResolveRelativeTarget = !1, this.relativeParent = this.getClosestProjectingParent(), this.relativeParent && !!this.relativeParent.resumingFrom == !!this.resumingFrom && !this.relativeParent.options.layoutScroll && this.relativeParent.target && (this.relativeTarget = B(), this.relativeTargetOrigin = B(), Bt(this.relativeTargetOrigin, this.target, this.relativeParent.target), Z(this.relativeTarget, this.relativeTargetOrigin)))));
      }, o.prototype.getClosestProjectingParent = function() {
        if (!(!this.parent || lt(this.parent.latestValues)))
          return (this.parent.relativeTarget || this.parent.targetDelta) && this.parent.layout ? this.parent : this.parent.getClosestProjectingParent();
      }, o.prototype.calcProjection = function() {
        var a, u = this.options, l = u.layout, c = u.layoutId;
        if (this.isTreeAnimating = !!(!((a = this.parent) === null || a === void 0) && a.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !(!this.layout || !(l || c))) {
          var f = this.getLead();
          Z(this.layoutCorrected, this.layout.actual), Uu(this.layoutCorrected, this.treeScale, this.path, !!this.resumingFrom || this !== f);
          var d = f.target;
          if (d) {
            this.projectionDelta || (this.projectionDelta = _t(), this.projectionDeltaWithTransform = _t());
            var p = this.treeScale.x, v = this.treeScale.y, h = this.projectionTransform;
            jt(this.projectionDelta, this.layoutCorrected, d, this.latestValues), this.projectionTransform = Lr(this.projectionDelta, this.treeScale), (this.projectionTransform !== h || this.treeScale.x !== p || this.treeScale.y !== v) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", d));
          }
        }
      }, o.prototype.hide = function() {
        this.isVisible = !1;
      }, o.prototype.show = function() {
        this.isVisible = !0;
      }, o.prototype.scheduleRender = function(a) {
        var u, l, c;
        a === void 0 && (a = !0), (l = (u = this.options).scheduleRender) === null || l === void 0 || l.call(u), a && ((c = this.getStack()) === null || c === void 0 || c.scheduleRender()), this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
      }, o.prototype.setAnimationOrigin = function(a, u) {
        var l = this, c;
        u === void 0 && (u = !1);
        var f = this.snapshot, d = (f == null ? void 0 : f.latestValues) || {}, p = g({}, this.latestValues), v = _t();
        this.relativeTarget = this.relativeTargetOrigin = void 0, this.attemptToResolveRelativeTarget = !u;
        var h = B(), m = f == null ? void 0 : f.isShared, y = (((c = this.getStack()) === null || c === void 0 ? void 0 : c.members.length) || 0) <= 1, P = !!(m && !y && this.options.crossfade === !0 && !this.path.some(kl));
        this.animationProgress = 0, this.mixTargetDelta = function(b) {
          var T, S = b / 1e3;
          Ir(v.x, a.x, S), Ir(v.y, a.y, S), l.setTargetDelta(v), l.relativeTarget && l.relativeTargetOrigin && l.layout && (!((T = l.relativeParent) === null || T === void 0) && T.layout) && (Bt(h, l.layout.actual, l.relativeParent.layout.actual), Hl(l.relativeTarget, l.relativeTargetOrigin, h, S)), m && (l.animationValues = p, xl(p, d, l.latestValues, S, P, y)), l.root.scheduleUpdateProjection(), l.scheduleRender(), l.animationProgress = S;
        }, this.mixTargetDelta(0);
      }, o.prototype.startAnimation = function(a) {
        var u = this, l, c;
        this.notifyListeners("animationStart"), (l = this.currentAnimation) === null || l === void 0 || l.stop(), this.resumingFrom && ((c = this.resumingFrom.currentAnimation) === null || c === void 0 || c.stop()), this.pendingAnimation && (Vt.update(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = Q.update(function() {
          Dt.hasAnimatedSinceResize = !0, u.currentAnimation = Pl(0, Dr, g(g({}, a), { onUpdate: function(f) {
            var d;
            u.mixTargetDelta(f), (d = a.onUpdate) === null || d === void 0 || d.call(a, f);
          }, onComplete: function() {
            var f;
            (f = a.onComplete) === null || f === void 0 || f.call(a), u.completeAnimation();
          } })), u.resumingFrom && (u.resumingFrom.currentAnimation = u.currentAnimation), u.pendingAnimation = void 0;
        });
      }, o.prototype.completeAnimation = function() {
        var a;
        this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0), (a = this.getStack()) === null || a === void 0 || a.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
      }, o.prototype.finishAnimation = function() {
        var a;
        this.currentAnimation && ((a = this.mixTargetDelta) === null || a === void 0 || a.call(this, Dr), this.currentAnimation.stop()), this.completeAnimation();
      }, o.prototype.applyTransformsToTarget = function() {
        var a = this.getLead(), u = a.targetWithTransforms, l = a.target, c = a.layout, f = a.latestValues;
        !u || !l || !c || (Z(u, l), Tt(u, f), jt(this.projectionDeltaWithTransform, this.layoutCorrected, u, f));
      }, o.prototype.registerSharedNode = function(a, u) {
        var l, c, f;
        this.sharedNodes.has(a) || this.sharedNodes.set(a, new El());
        var d = this.sharedNodes.get(a);
        d.add(u), u.promote({
          transition: (l = u.options.initialPromotionConfig) === null || l === void 0 ? void 0 : l.transition,
          preserveFollowOpacity: (f = (c = u.options.initialPromotionConfig) === null || c === void 0 ? void 0 : c.shouldPreserveFollowOpacity) === null || f === void 0 ? void 0 : f.call(c, u)
        });
      }, o.prototype.isLead = function() {
        var a = this.getStack();
        return a ? a.lead === this : !0;
      }, o.prototype.getLead = function() {
        var a, u = this.options.layoutId;
        return u ? ((a = this.getStack()) === null || a === void 0 ? void 0 : a.lead) || this : this;
      }, o.prototype.getPrevLead = function() {
        var a, u = this.options.layoutId;
        return u ? (a = this.getStack()) === null || a === void 0 ? void 0 : a.prevLead : void 0;
      }, o.prototype.getStack = function() {
        var a = this.options.layoutId;
        if (a)
          return this.root.sharedNodes.get(a);
      }, o.prototype.promote = function(a) {
        var u = a === void 0 ? {} : a, l = u.needsReset, c = u.transition, f = u.preserveFollowOpacity, d = this.getStack();
        d && d.promote(this, f), l && (this.projectionDelta = void 0, this.needsReset = !0), c && this.setOptions({ transition: c });
      }, o.prototype.relegate = function() {
        var a = this.getStack();
        return a ? a.relegate(this) : !1;
      }, o.prototype.resetRotation = function() {
        var a = this.options.visualElement;
        if (a) {
          for (var u = !1, l = {}, c = 0; c < ke.length; c++) {
            var f = ke[c], d = "rotate" + f;
            a.getStaticValue(d) && (u = !0, l[d] = a.getStaticValue(d), a.setStaticValue(d, 0));
          }
          if (u) {
            a == null || a.syncRender();
            for (var d in l)
              a.setStaticValue(d, l[d]);
            a.scheduleRender();
          }
        }
      }, o.prototype.getProjectionStyles = function(a) {
        var u, l, c, f, d, p;
        a === void 0 && (a = {});
        var v = {};
        if (!this.instance || this.isSVG)
          return v;
        if (this.isVisible)
          v.visibility = "";
        else
          return { visibility: "hidden" };
        var h = (u = this.options.visualElement) === null || u === void 0 ? void 0 : u.getProps().transformTemplate;
        if (this.needsReset)
          return this.needsReset = !1, v.opacity = "", v.pointerEvents = ue(a.pointerEvents) || "", v.transform = h ? h(this.latestValues, "") : "none", v;
        var m = this.getLead();
        if (!this.projectionDelta || !this.layout || !m.target) {
          var y = {};
          return this.options.layoutId && (y.opacity = (l = this.latestValues.opacity) !== null && l !== void 0 ? l : 1, y.pointerEvents = ue(a.pointerEvents) || ""), this.hasProjected && !lt(this.latestValues) && (y.transform = h ? h({}, "") : "none", this.hasProjected = !1), y;
        }
        var P = m.animationValues || m.latestValues;
        this.applyTransformsToTarget(), v.transform = Lr(this.projectionDeltaWithTransform, this.treeScale, P), h && (v.transform = h(P, v.transform));
        var b = this.projectionDelta, T = b.x, S = b.y;
        v.transformOrigin = "".concat(T.origin * 100, "% ").concat(S.origin * 100, "% 0"), m.animationValues ? v.opacity = m === this ? (f = (c = P.opacity) !== null && c !== void 0 ? c : this.latestValues.opacity) !== null && f !== void 0 ? f : 1 : this.preserveOpacity ? this.latestValues.opacity : P.opacityExit : v.opacity = m === this ? (d = P.opacity) !== null && d !== void 0 ? d : "" : (p = P.opacityExit) !== null && p !== void 0 ? p : 0;
        for (var E in de)
          if (P[E] !== void 0) {
            var M = de[E], A = M.correct, C = M.applyTo, L = A(P[E], m);
            if (C)
              for (var H = C.length, F = 0; F < H; F++)
                v[C[F]] = L;
            else
              v[E] = L;
          }
        return this.options.layoutId && (v.pointerEvents = m === this ? ue(a.pointerEvents) || "" : "none"), v;
      }, o.prototype.clearSnapshot = function() {
        this.resumeFrom = this.snapshot = void 0;
      }, o.prototype.resetTree = function() {
        this.root.nodes.forEach(function(a) {
          var u;
          return (u = a.currentAnimation) === null || u === void 0 ? void 0 : u.stop();
        }), this.root.nodes.forEach(Or), this.root.sharedNodes.clear();
      }, o;
    }()
  );
}
function Dl(t) {
  t.updateLayout();
}
function Ol(t) {
  var e, n, r, i, s = (n = (e = t.resumeFrom) === null || e === void 0 ? void 0 : e.snapshot) !== null && n !== void 0 ? n : t.snapshot;
  if (t.isLead() && t.layout && s && t.hasListeners("didUpdate")) {
    var o = t.layout, a = o.actual, u = o.measured;
    t.options.animationType === "size" ? tt(function(P) {
      var b = s.isShared ? s.measured[P] : s.layout[P], T = at(b);
      b.min = a[P].min, b.max = b.min + T;
    }) : t.options.animationType === "position" && tt(function(P) {
      var b = s.isShared ? s.measured[P] : s.layout[P], T = at(a[P]);
      b.max = b.min + T;
    });
    var l = _t();
    jt(l, a, s.layout);
    var c = _t();
    s.isShared ? jt(c, t.applyTransform(u, !0), s.measured) : jt(c, a, s.layout);
    var f = !lo(l), d = !1;
    if (!t.resumeFrom && (t.relativeParent = t.getClosestProjectingParent(), t.relativeParent && !t.relativeParent.resumeFrom)) {
      var p = t.relativeParent, v = p.snapshot, h = p.layout;
      if (v && h) {
        var m = B();
        Bt(m, s.layout, v.layout);
        var y = B();
        Bt(y, a, h.actual), co(m, y) || (d = !0);
      }
    }
    t.notifyListeners("didUpdate", {
      layout: a,
      snapshot: s,
      delta: c,
      layoutDelta: l,
      hasLayoutChanged: f,
      hasRelativeTargetChanged: d
    });
  } else
    t.isLead() && ((i = (r = t.options).onExitComplete) === null || i === void 0 || i.call(r));
  t.options.transition = void 0;
}
function Il(t) {
  t.clearSnapshot();
}
function Or(t) {
  t.clearMeasurements();
}
function Fl(t) {
  var e = t.options.visualElement;
  e != null && e.getProps().onBeforeLayoutMeasure && e.notifyBeforeLayoutMeasure(), t.resetTransform();
}
function jl(t) {
  t.finishAnimation(), t.targetDelta = t.relativeTarget = t.target = void 0;
}
function Bl(t) {
  t.resolveTargetDelta();
}
function _l(t) {
  t.calcProjection();
}
function Nl(t) {
  t.resetRotation();
}
function Ul(t) {
  t.removeLeadSnapshot();
}
function Ir(t, e, n) {
  t.translate = O(e.translate, 0, n), t.scale = O(e.scale, 1, n), t.origin = e.origin, t.originPoint = e.originPoint;
}
function Fr(t, e, n, r) {
  t.min = O(e.min, n.min, r), t.max = O(e.max, n.max, r);
}
function Hl(t, e, n, r) {
  Fr(t.x, e.x, n.x, r), Fr(t.y, e.y, n.y, r);
}
function kl(t) {
  return t.animationValues && t.animationValues.opacityExit !== void 0;
}
var zl = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
};
function Kl(t, e) {
  for (var n = t.root, r = t.path.length - 1; r >= 0; r--)
    if (t.path[r].instance) {
      n = t.path[r];
      break;
    }
  var i = n && n !== t.root ? n.instance : document, s = i.querySelector('[data-projection-id="'.concat(e, '"]'));
  s && t.mount(s, !0);
}
function jr(t) {
  t.min = Math.round(t.min), t.max = Math.round(t.max);
}
function Br(t) {
  jr(t.x), jr(t.y);
}
var Gl = fo({
  attachResizeListener: function(t, e) {
    return Ve(t, "resize", e);
  },
  measureScroll: function() {
    return {
      x: document.documentElement.scrollLeft || document.body.scrollLeft,
      y: document.documentElement.scrollTop || document.body.scrollTop
    };
  },
  checkIsScrollRoot: function() {
    return !0;
  }
}), _e = {
  current: void 0
}, Wl = fo({
  measureScroll: function(t) {
    return {
      x: t.scrollLeft,
      y: t.scrollTop
    };
  },
  defaultParent: function() {
    if (!_e.current) {
      var t = new Gl(0, {});
      t.mount(window), t.setOptions({ layoutScroll: !0 }), _e.current = t;
    }
    return _e.current;
  },
  resetTransform: function(t, e) {
    t.style.transform = e ?? "none";
  },
  checkIsScrollRoot: function(t) {
    return window.getComputedStyle(t).position === "fixed";
  }
}), Yl = g(g(g(g({}, Eu), Ys), Xu), bl), tc = /* @__PURE__ */ Uo(function(t, e) {
  return Aa(t, e, Yl, pl, Wl);
});
function vo() {
  var t = et(!1);
  return fe(function() {
    return t.current = !0, function() {
      t.current = !1;
    };
  }, []), t;
}
function $l() {
  var t = vo(), e = I(Nr(0), 2), n = e[0], r = e[1], i = Ue(function() {
    t.current && r(n + 1);
  }, [n]), s = Ue(function() {
    return Q.postRender(i);
  }, [i]);
  return [s, n];
}
var Ne = function(t) {
  var e = t.children, n = t.initial, r = t.isPresent, i = t.onExitComplete, s = t.custom, o = t.presenceAffectsLayout, a = $t(Xl), u = zi(), l = Nt(
    function() {
      return {
        id: u,
        initial: n,
        isPresent: r,
        custom: s,
        onExitComplete: function(c) {
          var f, d;
          a.set(c, !0);
          try {
            for (var p = po(a.values()), v = p.next(); !v.done; v = p.next()) {
              var h = v.value;
              if (!h)
                return;
            }
          } catch (m) {
            f = { error: m };
          } finally {
            try {
              v && !v.done && (d = p.return) && d.call(p);
            } finally {
              if (f)
                throw f.error;
            }
          }
          i == null || i();
        },
        register: function(c) {
          return a.set(c, !1), function() {
            return a.delete(c);
          };
        }
      };
    },
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    o ? void 0 : [r]
  );
  return Nt(function() {
    a.forEach(function(c, f) {
      return a.set(f, !1);
    });
  }, [r]), G.useEffect(function() {
    !r && !a.size && (i == null || i());
  }, [r]), G.createElement(Yt.Provider, { value: l }, e);
};
function Xl() {
  return /* @__PURE__ */ new Map();
}
var bt = function(t) {
  return t.key || "";
};
function Zl(t, e) {
  t.forEach(function(n) {
    var r = bt(n);
    e.set(r, n);
  });
}
function ql(t) {
  var e = [];
  return bo.forEach(t, function(n) {
    Po(n) && e.push(n);
  }), e;
}
var ec = function(t) {
  var e = t.children, n = t.custom, r = t.initial, i = r === void 0 ? !0 : r, s = t.onExitComplete, o = t.exitBeforeEnter, a = t.presenceAffectsLayout, u = a === void 0 ? !0 : a, l = I($l(), 1), c = l[0], f = j(un).forceRender;
  f && (c = f);
  var d = vo(), p = ql(e), v = p, h = /* @__PURE__ */ new Set(), m = et(v), y = et(/* @__PURE__ */ new Map()).current, P = et(!0);
  if (fe(function() {
    P.current = !1, Zl(p, y), m.current = v;
  }), gn(function() {
    P.current = !0, y.clear(), h.clear();
  }), P.current)
    return G.createElement(G.Fragment, null, v.map(function(A) {
      return G.createElement(Ne, { key: bt(A), isPresent: !0, initial: i ? void 0 : !1, presenceAffectsLayout: u }, A);
    }));
  v = J([], I(v), !1);
  for (var b = m.current.map(bt), T = p.map(bt), S = b.length, E = 0; E < S; E++) {
    var M = b[E];
    T.indexOf(M) === -1 && h.add(M);
  }
  return o && h.size && (v = []), h.forEach(function(A) {
    if (T.indexOf(A) === -1) {
      var C = y.get(A);
      if (C) {
        var L = b.indexOf(A), H = function() {
          y.delete(A), h.delete(A);
          var F = m.current.findIndex(function(_) {
            return _.key === A;
          });
          if (m.current.splice(F, 1), !h.size) {
            if (m.current = p, d.current === !1)
              return;
            c(), s && s();
          }
        };
        v.splice(L, 0, G.createElement(Ne, { key: bt(C), isPresent: !1, onExitComplete: H, custom: n, presenceAffectsLayout: u }, C));
      }
    }
  }), v = v.map(function(A) {
    var C = A.key;
    return h.has(C) ? A : G.createElement(Ne, { key: bt(A), isPresent: !0, presenceAffectsLayout: u }, A);
  }), an !== "production" && o && v.length > 1 && console.warn("You're attempting to animate multiple children within AnimatePresence, but its exitBeforeEnter prop is set to true. This will lead to odd visual behaviour."), G.createElement(G.Fragment, null, h.size ? v : v.map(function(A) {
    return yo(A);
  }));
};
export {
  ec as A,
  tc as m
};
